import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
  Divider,
  SelectChangeEvent,
  InputAdornment,
  Collapse,
} from "@mui/material";
import {
  Add,
  Delete,
  Download,
  FilterList,
  MoreVert,
  Search,
  FirstPage,
  LastPage,
  Close,
  PictureAsPdf,
  PhotoCamera,
  Remove,
  Check,
  FileCopy,
  ExpandMore,
  ExpandLess,
} from "@mui/icons-material";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import { styled } from "@mui/system";
import ImageIcon from "@mui/icons-material/Image";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FormHelperText from "@mui/material/FormHelperText";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { autoTable } from "jspdf-autotable";
import html2canvas from "html2canvas";
// import { logoBase64 } from './logo'; // Optional: sertakan logo perusahaan
import {
  fetchAhs,
  ahsSearchParams,
  getAhs,
  createAhs,
  deleteAhs,
  fetchCategoryItem,
  fetchItemDetails,
  fetchTenagaKerjaItems,
  fetchTenagaKerjaDetails,
  fetchBahanItems,
  fetchBahanDetails,
  fetchPeralatanItems,
  fetchPeralatanDetails,
  updateAhs,
  getAhsById,
  sesarchAhs,
  getAllItemDetails,
  duplicateAhs,
} from "../services/ahsService.tsx";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import LoadingOverlay from "../../../shared/components/LoadingOverlay.tsx";

interface AHSItem {
  item: string;
  harga: number;
}

interface AhsData {
  namaAHS: string;
  kategoriAHS: string;
  satuanAHS: string;
  kodeAHS: string;
  jumlahHargaTenagaKerja: string;
  jumlahHargaBahan: string;
  jumlahHargaPeralatan: string;
  overheadProfitKoefisien: string;
  jumlahOverheadProfitKoefisien: string;
}

interface CategoryItem {
  id: string;
  name: string;
  description: string;
  category: string;
  code: string;
}

const AHSListPage: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [allItemDetails, setAllItemDetails] = useState<any[]>([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddAHSDialog, setOpenAddAHSDialog] = useState(false);
  const [openEditAHSDialog, setOpenEditAHSDialog] = useState(false);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10); // Jumlah item per halaman
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [currentPage, setCurrentPage] = useState(1); // Halaman aktif
  const [totalPages, setTotalPages] = useState(1); // Total halaman

  // Fungsi untuk mengambil data ahs

  // Ahs Data Table ========================================================================
  // Fungsi untuk mengambil data ahs
  const reloadAHS = async () => {
    setIsLoading(true);
    setError(""); // Reset error sebelum memuat ulang data
    try {
      const result = await getAhs({
        ...filterParams, // ← nanti kamu tinggal simpan filter dari search input di state ini
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });
      setRows(result.data);
      setTotalItems(result.total);
      setTotalPages(result.pagination.totalPages);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllItemDetails = async () => {
    try {
      const result = await getAllItemDetails();
      setAllItemDetails(result);
    } catch (error) {
      console.error("Error fetching all item details:", error);
    }
  };

  const offset = (currentPage - 1) * rowsPerPage;

  const [filterParams, setFilterParams] = useState<{
    namaAHS?: string;
    ahsSubCode?: string;
    category?: string;
    sumber?: string;
    totalAHS?: string;
    keyword?: string;
  }>({});

  // Sort
  const [sortConfig, setSortConfig] = useState<{
    orderBy: string;
    order: "asc" | "desc";
  }>({
    orderBy: "createdAt",
    order: "desc",
  });

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };

  // Memanggil data saat komponen pertama kali dimuat
  useEffect(() => {
    reloadAHS();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);

  // Fungsi untuk menangani pemilihan checkbox baris
  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const CustomTextField = styled(TextField)({
    "& .MuiInputBase-input": {
      backgroundColor: "#f5f5f5",
      borderRadius: 4,
      padding: "8px 12px",
    },
  });

  const handleDeleteRows = async () => {
    try {
      await Promise.all(selectedRows.map((id) => deleteAhs(id.toString())));

      Swal.fire({
        icon: "success",
        title: "Analisa Harga Satuan berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });

      setSelectedRows([]);
      reloadAHS();
      setOpenDeleteDialog(false);
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus ahs",
        text:
          error.response?.data?.message || error.message || "Terjadi kesalahan",
      });
    }
  };

  // 🔄 Pastikan selectedRows update setelah rows berubah
  useEffect(() => {
    setSelectedRows([]);
  }, [rows]);

  const [filters, setFilters] = useState([{ field: "namaAHS", value: "" }]);
  const [ahs, setAhs] = useState();

  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "namaAHS", label: "AHS Name" },
    { value: "ahsSubCode", label: "Kode" },
    { value: "category", label: "AHS Category" },
    { value: "sumber", label: "Sumber" },
    { value: "totalAHS", label: "Harga Satuan Pekerjaan" },
  ];

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      // Buat object parameter pencarian sesuai `ItemSearchParams`
      const searchParams: ahsSearchParams = {};

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });

      // // Panggil fungsi pencarian dari itemServices.tsx
      // const response = await getItems(searchParams);
      // console.log(response);
      // // Format hasil pencarian sebelum ditampilkan di tabel
      // handleSearchResults(response.data);

      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "namaAHS", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
  };

  //======================= Search ===================================
  const handleSearch = async () => {
    // if (searchQuery.trim() === "") return; // Hindari pencarian kosong
    setIsLoading(true);
    setError("");

    try {
      // const results = await getAhss({
      //   keyword: searchQuery,
      //   limit: rowsPerPage,
      //   offset,
      // });
      setFilterParams({
        keyword: searchQuery,
      });
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  //== Duplikasi AHS ==
  const handleDuplicate = async (id: string, namaAHS: string) => {
    const { value: newName, isConfirmed } = await Swal.fire({
      title: "Duplikasi AHS",
      html: `<p style="margin-bottom:8px;font-size:14px;color:#555;">Beri nama untuk AHS hasil duplikasi:</p>`,
      input: "text",
      inputValue: namaAHS,
      inputPlaceholder: "Nama AHS baru...",
      showCancelButton: true,
      confirmButtonText: "Duplikasi",
      cancelButtonText: "Batal",
      confirmButtonColor: "#1976d2",
      inputAttributes: { autocomplete: "off" },
      inputValidator: (value) => {
        if (!value || value.trim() === "") {
          return "Nama AHS tidak boleh kosong!";
        }
      },
    });

    if (!isConfirmed) return;

    try {
      Swal.fire({
        title: "Menduplikasi...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      await duplicateAhs(id, newName.trim());

      await Swal.fire({
        icon: "success",
        title: "Berhasil!",
        text: `AHS "${newName.trim()}" berhasil diduplikasi.`,
        timer: 2000,
        showConfirmButton: false,
      });

      reloadAHS();
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : "Terjadi kesalahan.";
      Swal.fire({ icon: "error", title: "Gagal", text: message });
    }
  };

  //== export excel table==

  const handleExportExcel = async () => {
    try {
      // Tampilkan loading
      Swal.fire({
        title: "Mempersiapkan Export...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Ambil data yang akan diexport
      const exportData = await getExportData();

      // Buat worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Buat workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Analisa Harga Satuan");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `AHS_Export_${date}.xlsx`);

      // Tutup loading
      Swal.close();
    } catch (error) {
      console.error("Gagal export:", error);
      Swal.fire({
        icon: "error",
        title: "Export Gagal",
        text: error.message || "Terjadi kesalahan saat mengekspor data",
      });
    }
  };

  // Fungsi untuk mengambil dan memformat data AHS
  const getExportData = async () => {
    // Ambil data AHS dengan filter yang sama seperti tabel
    const response = await getAhs({
      ...filterParams,
      limit: 1000000, // Ambil semua data
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });

    // Format data untuk export sesuai tampilan edit
    return await Promise.all(
      response.data.map(async (ahs) => {
        // Ambil detail AHS untuk mendapatkan informasi lengkap
        const ahsDetail = await getAhsById(ahs.id);

        const formatNumber = (value) => {
          if (value === null || value === undefined) return "";
          const num = Number(value);
          if (isNaN(num)) return value;
          return num.toString().replace(/,/g, "."); // Replace comma with dot
        };

        const formatTimestampz = (
          timestamp: string | Date | null,
          withTime: boolean = true
        ): string => {
          if (!timestamp) return "-";

          const date = new Date(timestamp);

          if (isNaN(date.getTime())) return "Invalid Date";

          // Format tanggal: DD/MM/YYYY
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          const datePart = `${day}/${month}/${year}`;

          if (!withTime) return datePart;

          // Format waktu: HH:MM:SS
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const timePart = `${hours}:${minutes}:${seconds}`;


          return `${datePart} ${timePart}`;
        };

        // Parse items if it's a string
        let items = ahsDetail.items;
        if (typeof items === 'string') {
          try {
            items = JSON.parse(items);
          } catch (parseError) {
            console.error("Failed to parse items JSON for export:", parseError);
            items = [];
          }
        }
        
        // Ensure items is an array
        if (!Array.isArray(items)) {
          console.error("Items is not an array for export:", items);
          items = [];
        }

        return {
          // Informasi header
          "ID AHS": ahs.id,
          "Nama AHS": ahs.namaAHS,
          Kategori: ahs.category,
          Satuan: ahs.satuanAHS.toLocaleString("id-ID"),
          "Kode AHS": ahs.ahsSubCode,
          Sumber: ahs.sumber,

          // Bagian tenaga kerja
          ...formatItemsForExport(
            items.filter((item) => item.tenagaKerja),
            "Tenaga Kerja"
          ),

          // Bagian bahan
          ...formatItemsForExport(
            items.filter((item) => item.bahan),
            "Bahan"
          ),

          // Bagian peralatan
          ...formatItemsForExport(
            items.filter((item) => item.peralatan),
            "Peralatan"
          ),

          // Perhitungan
          "Jumlah Harga Tenaga Kerja": formatNumber(ahs.jumlahHargaTenagaKerja),
          "Jumlah Harga Bahan": formatNumber(ahs.jumlahHargaBahan),
          "Jumlah Harga Peralatan": formatNumber(ahs.jumlahHargaPeralatan),
          "Overhead Profit Koefisien (%)": ahs.overheadKoefisien,
          "Jumlah Overhead Profit": formatNumber(ahs.jumlahOverheadProfitKoefisien),
          "Total A+B+C": formatNumber(ahs.totalJumlahHargaABC),
          "Total D+E": formatNumber(ahs.totalJumlahHargaDE),
          "Total AHS": formatNumber(ahs.totalAHS),
          "Tanggal Dibuat": formatTimestampz(ahs.createdAt) || "-",
          "Tanggal Diupdate": formatTimestampz(ahs.updateAt) || "-",
        };
      })
    );
  };

  // Fungsi untuk memformat item (tenaga kerja, bahan, peralatan)
  const formatItemsForExport = (items: any[], type: string) => {
    const result: any = {};

    const formatNumber = (value) => {
      if (value === null || value === undefined) return "";
      const num = Number(value);
      if (isNaN(num)) return value;
      return num.toString().replace(/,/g, "."); // Replace comma with dot
    };

    items.forEach((item, index) => {
      const prefix = `${type} ${index + 1}`;

      result[`${prefix} - Nama`] =
        item.tenagaKerja || item.bahan || item.peralatan;
      result[`${prefix} - Deskripsi`] =
        item.descriptionTenagaKerja ||
        item.descriptionBahan ||
        item.descriptionPeralatan;
      result[`${prefix} - Koefisien`] =
        item.koefisienTenagaKerja ||
        item.koefisienBahan ||
        item.koefisienPeralatan;
      result[`${prefix} - Harga`] =
        item.hargaTenagaKerja || item.hargaBahan || item.hargaPeralatan;
      result[`${prefix} - Satuan Pembelian`] =
        item.purchaseUnitTenagaKerja ||
        item.purchaseUnitBahan ||
        item.purchaseUnitPeralatan;
      result[`${prefix} - Harga Satuan`] =
        formatNumber(item.unitPriceIDRTenagaKerja) ||
        formatNumber(item.unitPriceIDRBahan) ||
        formatNumber(item.unitPriceIDRPeralatan);

      // Format unit measurement
      const unitMeasurement = JSON.parse(
        item.unitMeasurementTenagaKerja ||
        item.unitMeasurementBahan ||
        item.unitMeasurementPeralatan ||
        "[]"
      );

      unitMeasurement.forEach((unit: any, i: number) => {
        result[`${prefix} - Unit ${i + 1}`] = unit.unit;
        result[`${prefix} - Ukuran ${i + 1}`] = unit.size;
      });
    });

    return result;
  };

  //== export excel detail================================================
  const exportToSingleSheetExcel = () => {
    // Helper function to format numbers with dot as decimal separator
    const formatNumber = (value) => {
      if (value === null || value === undefined) return "";
      const num = Number(value);
      if (isNaN(num)) return value;
      return num.toString().replace(/,/g, "."); // Replace comma with dot
    };

    // Data untuk Excel
    const excelData = [
      // Header
      ["Analisis Harga Satuan (AHS)"],
      ["Nama AHS:", ahsDataEdit.namaAHS],
      ["Kategori AHS:", ahsDataEdit.kategoriAHS],
      ["Sumber:", ahsDataEdit.sumber],
      ["Satuan AHS:", ahsDataEdit.satuanAHS],
      ["Kode AHS:", ahsDataEdit.kodeAHS],
      [], // Baris kosong

      // Section A: Tenaga Kerja
      ["A. TENAGA KERJA"],
      [
        "No",
        "Tenaga Kerja",
        "Deskripsi",
        "Unit Pengukuran (Ukuran)",
        "Koefisien",
        "Harga Satuan (Rp)",
        "Total Harga (Rp)",
      ],
      ...sectionsTenagaKerjaEdit.map((section, index) => [
        `${index + 1}`,
        section.tenagaKerja,
        section.descriptionTenagaKerja,
        Array.isArray(section.unitMeasurementTenagaKerja)
          ? section.unitMeasurementTenagaKerja
            .map((unit) => `${unit.unit || "-"} (${unit.size || "-"})`)
            .join(", ")
          : section.unitMeasurementTenagaKerja || "-",
        formatNumber(section.koefisienTenagaKerja),
        formatNumber(section.unitPriceIDRTenagaKerja),
        formatNumber(section.hargaTenagaKerja),
      ]),
      [
        "",
        "",
        "",
        "",
        "",
        "Jumlah Harga Tenaga Kerja:",
        formatNumber(ahsDataEdit.jumlahHargaTenagaKerja),
      ],
      [], // Baris kosong

      // Section B: Bahan
      ["B. BAHAN"],
      [
        "No",
        "Bahan",
        "Deskripsi",
        "Unit Pengukuran (Ukuran)",
        "Koefisien",
        "Harga Satuan (Rp)",
        "Total Harga (Rp)",
      ],
      ...sectionsBahanEdit.map((section, index) => [
        `${index + 1}`,
        section.bahan,
        section.descriptionBahan,
        Array.isArray(section.unitMeasurementBahan)
          ? section.unitMeasurementBahan
            .map((unit) => `${unit.unit || "-"} (${unit.size || "-"})`)
            .join(", ")
          : section.unitMeasurementBahan || "-",
        formatNumber(section.koefisienBahan),
        formatNumber(section.unitPriceIDRBahan),
        formatNumber(section.hargaBahan),
      ]),
      [
        "",
        "",
        "",
        "",
        "",
        "Jumlah Harga Bahan:",
        formatNumber(ahsDataEdit.jumlahHargaBahan),
      ],
      [], // Baris kosong

      // Section C: Peralatan
      ["C. PERALATAN"],
      [
        "No",
        "Peralatan",
        "Deskripsi",
        "Unit Pengukuran (Ukuran)",
        "Koefisien",
        "Harga Satuan (Rp)",
        "Total Harga (Rp)",
      ],
      ...sectionsPeralatanEdit.map((section, index) => [
        `${index + 1}`,
        section.peralatan,
        section.descriptionPeralatan,
        Array.isArray(section.unitMeasurementPeralatan)
          ? section.unitMeasurementPeralatan
            .map((unit) => `${unit.unit || "-"} (${unit.size || "-"})`)
            .join(", ")
          : section.unitMeasurementPeralatan || "-",
        formatNumber(section.koefisienPeralatan),
        formatNumber(section.unitPriceIDRPeralatan),
        formatNumber(section.hargaPeralatan),
      ]),
      [
        "",
        "",
        "",
        "",
        "",
        "Jumlah Harga Peralatan:",
        formatNumber(ahsDataEdit.jumlahHargaPeralatan),
      ],
      [], // Baris kosong

      // Section D: Jumlah (A+B+C)
      [
        "D. JUMLAH (A+B+C)",
        "",
        "",
        "",
        "",
        "",
        formatNumber(totalJumlahHargaABCEdit),
      ],
      [], // Baris kosong

      // Section E: Overhead & Profit
      ["E. OVERHEAD & PROFIT"],
      [
        "Koefisien (%)",
        "",
        "",
        "",
        formatNumber(ahsDataEdit.overheadProfitKoefisien),
      ],
      [
        "Jumlah (Rp)",
        "",
        "",
        "",
        "",
        "",
        formatNumber(ahsDataEdit.jumlahOverheadProfitKoefisien),
      ],
      [], // Baris kosong

      // Section F: Total (D+E)
      [
        "F. HARGA SATUAN PEKERJAAN (D+E)",
        "",
        "",
        "",
        "",
        "",
        formatNumber(totalJumlahHargaDEEdit),
      ],
    ];

    // Buat worksheet
    const ws = XLSX.utils.aoa_to_sheet(excelData);

    // Atur lebar kolom
    ws["!cols"] = [
      { wch: 10 }, // Kolom A (No)
      { wch: 25 }, // Kolom B (Nama Item)
      { wch: 30 }, // Kolom C (Deskripsi)
      { wch: 25 }, // Kolom D (Unit Pengukuran)
      { wch: 10 }, // Kolom E (Koefisien)
      { wch: 15 }, // Kolom F (Harga Satuan)
      { wch: 15 }, // Kolom G (Total Harga)
    ];

    // Format angka sebagai number dengan 2 desimal
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell_address = { c: C, r: R };
        const cell_ref = XLSX.utils.encode_cell(cell_address);
        if (ws[cell_ref] && ws[cell_ref].t === "n") {
          ws[cell_ref].z = "#,##0.00";
        }
      }
    }

    // Buat workbook dan ekspor
    const wb = XLSX.utils.book_new();
    const date = new Date().toISOString().slice(0, 10);
    XLSX.utils.book_append_sheet(wb, ws, "AHS");
    XLSX.writeFile(
      wb,
      `Analisis_Harga_Satuan_${ahsDataEdit.kodeAHS}_${date}.xlsx`
    );
  };

  //== export pdf detail================================================
  // Helper function untuk load image
  const loadImageAsBase64 = (url: string): Promise<string> => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous"; // Untuk handle CORS jika diperlukan
      img.src = url;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) return reject(new Error("Could not create canvas context"));

        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/jpeg"));
      };

      img.onerror = (err) => reject(new Error(`Gagal memuat gambar: ${url}`));
    });
  };

  const exportToPDF = async () => {
    try {
      const doc = new jsPDF();

      // 1. Debug: Cek apakah fungsi terpanggil
      console.log("Memulai proses export PDF...");

      // 2. Tambahkan gambar header
      try {
        const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
        console.log("Mencoba memuat gambar dari:", headerImageUrl);

        // Method 1: Menggunakan fetch + FileReader (lebih reliable)
        const response = await fetch(headerImageUrl);
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);

        const blob = await response.blob();
        const base64Image = await new Promise<string>((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result as string);
          reader.readAsDataURL(blob);
        });

        console.log(
          "Gambar berhasil dikonversi ke base64 (panjang):",
          base64Image.length
        );
        doc.addImage(base64Image, "JPEG", -10, 0, 230, 40);
        console.log("Gambar header berhasil ditambahkan ke PDF");
      } catch (imgError) {
        console.error("Gagal memuat gambar header:", imgError);
        // Fallback: Lanjut tanpa gambar jika error
      }

      // Tambahkan garis horizontal setelah gambar header
      doc.setDrawColor(0); // Warna hitam
      doc.setLineWidth(0.5); // Ketebalan garis
      doc.line(10, 37, 200, 37); // Garis dari x=10 ke x=200 pada y=45

      // 3. Konten utama (disesuaikan posisi Y jika ada gambar)
      const startY = 60; // Posisi awal lebih rendah untuk memberi ruang header

      // Judul utama (dipindahkan ke bawah header)
      doc.setFontSize(18);
      doc.text(`${ahsDataEdit.namaAHS || "-"}`, 105, startY - 15, {
        align: "center",
      });

      // Header Info (dipindahkan ke bawah judul)
      doc.setFontSize(10);

      // Kode
      doc.text("Kode", 15, startY - 10);
      doc.text(":", 27, startY - 10);
      doc.setFont("helvetica", "bold"); // Specify font family and style
      doc.text(`${ahsDataEdit.kodeAHS || "-"}`, 29, startY - 10);
      doc.setFont("helvetica", "normal"); // Reset to normal

      // Satuan
      doc.text("Satuan", 15, startY - 5);
      doc.text(":", 27, startY - 5);
      doc.setFont("helvetica", "bold"); // Set to bold again
      doc.text(`${ahsDataEdit.satuanAHS || "-"}`, 29, startY - 5);
      doc.setFont("helvetica", "normal"); // Reset to normal

      // Helper untuk format mata uang
      const formatRupiah = (value: number) => {
        return new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(value || 0);
      };

      // ===== TENAGA KERJA =====
      doc.setFontSize(12);
      doc.text("A. Tenaga Kerja", 15, startY + 2);
      autoTable(doc, {
        head: [
          [
            "No",
            "Tenaga Kerja",
            "Deskripsi",
            "Purchase Unit",
            "Unit Pengukuran (Ukuran)",
            "Koef",
            "Harga Satuan",
            "Total",
          ],
        ],
        body: sectionsTenagaKerjaEdit.map((item, i) => [
          `${i + 1}`,
          item.tenagaKerja || "-",
          item.descriptionTenagaKerja || "-",
          item.purchaseUnitTenagaKerja || "-",
          Array.isArray(item.unitMeasurementTenagaKerja)
            ? item.unitMeasurementTenagaKerja
              .map((unit) => `${unit.unit || "-"} (${unit.size || "-"})`)
              .join("\n")
            : item.unitMeasurementTenagaKerja || "-",
          item.koefisienTenagaKerja || "0",
          formatRupiah(Number(item.unitPriceIDRTenagaKerja)),
          formatRupiah(Number(item.hargaTenagaKerja)),
        ]),
        startY: startY + 4,
        margin: { top: 20 },
        headStyles: {
          fillColor: [169, 169, 169],
          textColor: 255,
          fontStyle: "bold",
        },
        styles: {
          cellPadding: 2,
          fontSize: 8,
        },
        columnStyles: {
          4: { cellWidth: "auto", minCellHeight: 10 },
        },
        didDrawPage: function (data) {
          // Add total labor cost
          const finalY = data.cursor.y + 5;
          doc.setFontSize(10);
          doc.setFont("helvetica", "bold");
          doc.text("Jumlah Harga Tenaga Kerja:", 110, finalY);
          doc.text(
            formatRupiah(Number(ahsDataEdit.jumlahHargaTenagaKerja)),
            195,
            finalY,
            {
              align: "right",
            }
          );
          doc.setFont("helvetica", "normal");
        },
      });

      // ===== BAHAN =====
      doc.setFontSize(12);
      doc.text("B. Bahan", 15, (doc as any).lastAutoTable.finalY + 13);
      autoTable(doc, {
        head: [
          [
            "No",
            "Bahan",
            "Deskripsi",
            "Purchase Unit",
            "Unit Pengukuran (Ukuran)",
            "Koef",
            "Harga Satuan",
            "Total",
          ],
        ],
        body: sectionsBahanEdit.map((item, i) => [
          `${i + 1}`,
          item.bahan || "-",
          item.descriptionBahan || "-",
          item.purchaseUnitBahan || "-",
          Array.isArray(item.unitMeasurementBahan)
            ? item.unitMeasurementBahan
              .map((unit) => `${unit.unit || "-"} (${unit.size || "-"})`)
              .join("\n")
            : item.unitMeasurementBahan || "-",
          item.koefisienBahan || "0",
          formatRupiah(Number(item.unitPriceIDRBahan)),
          formatRupiah(Number(item.hargaBahan)),
        ]),
        startY: (doc as any).lastAutoTable.finalY + 15,
        headStyles: {
          fillColor: [169, 169, 169],
          textColor: 255,
          fontStyle: "bold",
        },
        styles: {
          cellPadding: 2,
          fontSize: 8,
        },
        columnStyles: {
          4: { cellWidth: "auto" },
        },
        didDrawPage: function (data) {
          // Add total material cost
          const finalY = data.cursor.y + 5;
          doc.setFontSize(10);
          doc.setFont("helvetica", "bold");
          doc.text("Jumlah Harga Bahan:", 110, finalY);
          doc.text(
            formatRupiah(Number(ahsDataEdit.jumlahHargaBahan)),
            195,
            finalY,
            {
              align: "right",
            }
          );
          doc.setFont("helvetica", "normal");
        },
      });

      // ===== PERALATAN =====
      doc.setFontSize(12);
      doc.text("C. Peralatan", 15, (doc as any).lastAutoTable.finalY + 13);
      autoTable(doc, {
        head: [
          [
            "No",
            "Peralatan",
            "Deskripsi",
            "Purchase Unit",
            "Unit Pengukuran (Ukuran)",
            "Koef",
            "Harga Satuan",
            "Total",
          ],
        ],
        body: sectionsPeralatanEdit.map((item, i) => [
          `${i + 1}`,
          item.peralatan || "-",
          item.descriptionPeralatan || "-",
          item.purchaseUnitPeralatan || "-",
          Array.isArray(item.unitMeasurementPeralatan)
            ? item.unitMeasurementPeralatan
              .map((unit) => `${unit.unit || "-"} (${unit.size || "-"})`)
              .join("\n")
            : item.unitMeasurementPeralatan || "-",
          item.koefisienPeralatan || "0",
          formatRupiah(Number(item.unitPriceIDRPeralatan)),
          formatRupiah(Number(item.hargaPeralatan)),
        ]),
        startY: (doc as any).lastAutoTable.finalY + 15,
        headStyles: {
          fillColor: [169, 169, 169],
          textColor: 255,
          fontStyle: "bold",
        },
        styles: {
          cellPadding: 2,
          fontSize: 8,
        },
        columnStyles: {
          4: { cellWidth: "auto" },
        },
        didDrawPage: function (data) {
          // Add total equipment cost
          const finalY = data.cursor.y + 5;
          doc.setFontSize(10);
          doc.setFont("helvetica", "bold");
          doc.text("Jumlah Harga Peralatan:", 110, finalY);
          doc.text(
            formatRupiah(Number(ahsDataEdit.jumlahHargaPeralatan)),
            195,
            finalY,
            {
              align: "right",
            }
          );
          doc.setFont("helvetica", "normal");
        },
      });

      // ===== SUMMARY SECTION =====
      const summaryStartY = (doc as any).lastAutoTable.finalY + 15;

      // D. Jumlah (A+B+C) Table
      doc.setFontSize(12);
      doc.text("D. Jumlah (A+B+C)", 15, summaryStartY);
      autoTable(doc, {
        head: [["No", "Deskripsi", "Total"]],
        body: [["1", "Jumlah (A+B+C)", formatRupiah(totalJumlahHargaABCEdit)]],
        startY: summaryStartY + 5,
        margin: { left: 15 },
        headStyles: {
          fillColor: [169, 169, 169],
          textColor: 255,
          fontStyle: "bold",
        },
        styles: {
          cellPadding: 2,
          fontSize: 10,
        },
        columnStyles: {
          0: { cellWidth: 20 },
          1: { cellWidth: 110 },
          2: { cellWidth: 50, halign: "left" },
        },
      });

      // E. Overhead & Profit Table
      const overheadStartY = (doc as any).lastAutoTable.finalY + 10;
      doc.setFontSize(12);
      doc.text("E. Overhead & Profit", 15, overheadStartY);
      autoTable(doc, {
        head: [["No", "Deskripsi", "Koef", "Total"]],
        body: [
          [
            "1",
            "Overhead & Profit",
            `${ahsDataEdit.overheadProfitKoefisien || 0}%`,
            formatRupiah(Number(ahsDataEdit.jumlahOverheadProfitKoefisien)),
          ],
        ],
        startY: overheadStartY + 5,
        margin: { left: 15 },
        headStyles: {
          fillColor: [169, 169, 169],
          textColor: 255,
          fontStyle: "bold",
        },
        styles: {
          cellPadding: 2,
          fontSize: 10,
        },
        columnStyles: {
          0: { cellWidth: 20 },
          1: { cellWidth: 80 },
          2: { cellWidth: 30, halign: "left" },
          3: { cellWidth: 50, halign: "left" },
        },
      });

      // F. Harga Satuan Pekerjaan (D+E) Table
      const finalStartY = (doc as any).lastAutoTable.finalY + 10;
      doc.setFontSize(12);
      doc.text("F. Harga Satuan Pekerjaan (D+E)", 15, finalStartY);
      autoTable(doc, {
        head: [["No", "Deskripsi", "Total"]],
        body: [
          [
            "1",
            "Harga Satuan Pekerjaan (D+E)",
            formatRupiah(totalJumlahHargaDEEdit),
          ],
        ],
        startY: finalStartY + 5,
        margin: { left: 15 },
        headStyles: {
          fillColor: [100, 100, 100],
          textColor: 255,
          fontStyle: "bold",
        },
        bodyStyles: {
          fillColor: [240, 240, 240],
          textColor: 0,
          fontStyle: "bold",
        },
        styles: {
          cellPadding: 3,
          fontSize: 11,
        },
        columnStyles: {
          0: { cellWidth: 20 },
          1: { cellWidth: 110 },
          2: { cellWidth: 50, halign: "left" },
        },
      });

      // 4. Save PDF
      const date = new Date().toISOString().slice(0, 10);
      doc.save(`AHS_${ahsDataEdit.kodeAHS || "new"}_${date}.pdf`);
    } catch (error) {
      console.error("Error dalam export PDF:", error);
    }
  };

  const kategoriOptions = [
    { value: "Pekerjaan Persiapan", label: "Pekerjaan Persiapan" },
    { value: "Pekerjaan Tanah", label: "Pekerjaan Tanah" },
    { value: "Pekerjaan Pondasi", label: "Pekerjaan Pondasi" },
    { value: "Pekerjaan Beton", label: "Pekerjaan Beton" },
    {
      value: "Pekerjaan Besi & Alumunium",
      label: "Pekerjaan Besi & Alumunium",
    },
    { value: "Pekerjaan Pasang Dinding", label: "Pekerjaan Pasang Dinding" },
    {
      value: "Pekerjaan Plesteran & Acian",
      label: "Pekerjaan Plesteran & Acian",
    },
    { value: "Pekerjaan Keramik", label: "Pekerjaan Keramik" },
    { value: "Pekerjaan Langit-Langit", label: "Pekerjaan Langit-Langit" },
    { value: "Pekerjaan Penutup Atap", label: "Pekerjaan Penutup Atap" },
    { value: "Pekerjaan Kayu", label: "Pekerjaan Kayu" },
    { value: "Pekerjaan Kunci & Kaca", label: "Pekerjaan Kunci & Kaca" },
    { value: "Pekerjaan Pengecatan", label: "Pekerjaan Pengecatan" },
    { value: "Pekerjaan Sanitasi", label: "Pekerjaan Sanitasi" },
    {
      value: "Pekerjaan Fasade & Infrastruktur",
      label: "Pekerjaan Fasade & Infrastruktur",
    },
  ];

  const sumberOptions = [
    { value: "Manual Survey", label: "Manual Survey" },
    { value: "PUPR", label: "PUPR" },
  ];

  const getAvailableTenagaKerjaItems = (currentIndex: number) => {
    // Pastikan allItemDetailsTK adalah array
    if (!Array.isArray(allItemDetailsTK)) {
      console.error("allItemDetailsTK is not an array:", allItemDetailsTK);
      return [];
    }

    // Dapatkan ID yang sudah dipilih di section lain (kecuali currentIndex)
    const selectedInOtherSections = sectionsTenagaKerjaAdd
      .filter((_, idx) => idx !== currentIndex)
      .map((section) => section.idTk)
      .filter((id): id is string => !!id); // Pastikan hanya string yang valid

    // Item yang sedang dipilih di section ini (jika ada)
    const currentItemId = sectionsTenagaKerjaAdd[currentIndex]?.idTk;

    return allItemDetailsTK
      .filter(
        (item): item is { id: string; itemDetailName: string } =>
          !!item &&
          typeof item.id === "string" &&
          typeof item.itemDetailName === "string"
      )
      .filter((item) => {
        // Sertakan item jika:
        // 1. Tidak dipilih di section lain, ATAU
        // 2. Ini adalah item yang sedang dipilih di section ini
        return (
          !selectedInOtherSections.includes(item.id) ||
          item.id === currentItemId
        );
      })
      .map((item) => ({
        id: item.id,
        name: item.itemDetailName,
      }));
  };

  const getAvailableBahanItems = (currentIndex: number) => {
    // Pastikan allItemDetailsTK adalah array
    if (!Array.isArray(allItemDetailsBahan)) {
      console.error("allItemDetailsTK is not an array:", allItemDetailsBahan);
      return [];
    }

    // Dapatkan ID yang sudah dipilih di section lain (kecuali currentIndex)
    const selectedInOtherSections = sectionsBahanAdd
      .filter((_, idx) => idx !== currentIndex)
      .map((section) => section.idBahan)
      .filter((id): id is string => !!id); // Pastikan hanya string yang valid

    // Item yang sedang dipilih di section ini (jika ada)
    const currentItemId = sectionsBahanAdd[currentIndex]?.idBahan;

    return allItemDetailsBahan
      .filter(
        (item): item is { id: string; itemDetailName: string } =>
          !!item &&
          typeof item.id === "string" &&
          typeof item.itemDetailName === "string"
      )
      .filter((item) => {
        // Sertakan item jika:
        // 1. Tidak dipilih di section lain, ATAU
        // 2. Ini adalah item yang sedang dipilih di section ini
        return (
          !selectedInOtherSections.includes(item.id) ||
          item.id === currentItemId
        );
      })
      .map((item) => ({
        id: item.id,
        name: item.itemDetailName,
      }));
  };

  const getAvailablePeralatanItems = (currentIndex: number) => {
    // Pastikan allItemDetailsTK adalah array
    if (!Array.isArray(allItemDetailsPeralatan)) {
      console.error(
        "allItemDetailsPeralatan is not an array:",
        allItemDetailsPeralatan
      );
      return [];
    }

    // Dapatkan ID yang sudah dipilih di section lain (kecuali currentIndex)
    const selectedInOtherSections = sectionsPeralatanAdd
      .filter((_, idx) => idx !== currentIndex)
      .map((section) => section.idPeralatan)
      .filter((id): id is string => !!id); // Pastikan hanya string yang valid

    // Item yang sedang dipilih di section ini (jika ada)
    const currentItemId = sectionsPeralatanAdd[currentIndex]?.idPeralatan;

    return allItemDetailsPeralatan
      .filter(
        (item): item is { id: string; itemDetailName: string } =>
          !!item &&
          typeof item.id === "string" &&
          typeof item.itemDetailName === "string"
      )
      .filter((item) => {
        // Sertakan item jika:
        // 1. Tidak dipilih di section lain, ATAU
        // 2. Ini adalah item yang sedang dipilih di section ini
        return (
          !selectedInOtherSections.includes(item.id) ||
          item.id === currentItemId
        );
      })
      .map((item) => ({
        id: item.id,
        name: item.itemDetailName,
      }));
  };

  // add ahs data ========================================================================
  const [ahsDataAdd, setAhsDataAdd] = useState({
    namaAHS: "",
    kategoriAHS: "",
    satuanAHS: "",
    kodeAHS: "",
    sumber: "",
    jumlahHargaTenagaKerja: "",
    jumlahHargaBahan: "",
    jumlahHargaPeralatan: "",
    overheadProfitKoefisien: "",
    jumlahOverheadProfitKoefisien: "",
  });

  const [categoryItemsTK, setCategoryItemsTK] = useState<CategoryItem[]>([]);
  const [loadingCategoryItemsTK, setLoadingCategoryItemsTK] = useState(false);
  const [loadingDetailItemsTK, setLoadingDetailItemsTK] = useState(false);
  const [categoryItemsBahan, setCategoryItemsBahan] = useState<CategoryItem[]>(
    []
  );
  const [loadingCategoryItemsBahan, setLoadingCategoryItemsBahan] =
    useState(false);
  const [loadingDetailItemsBahan, setLoadingDetailItemsBahan] = useState(false);
  const [categoryItemsPeralatan, setCategoryItemsPeralatan] = useState<
    CategoryItem[]
  >([]);
  const [loadingCategoryItemsPeralatan, setLoadingCategoryItemsPeralatan] =
    useState(false);
  const [loadingDetailItemsPeralatan, setLoadingDetailItemsPeralatan] =
    useState(false);

  const [sectionsTenagaKerjaAdd, setSectionsTenagaKerjaAdd] = useState([
    {
      idTk: "",
      tenagaKerja: "",
      descriptionTenagaKerja: "",
      koefisienTenagaKerja: "",
      hargaTenagaKerja: "",
      purchaseUnitTenagaKerja: "",
      unitPriceIDRTenagaKerja: "",
      unitMeasurementTenagaKerja: [],
      inputUnitTenagaKerja: "",
      ukuranTenagaKerja: "",
      itemIdTk: "",
    },
  ]);

  const [sectionsBahanAdd, setSectionsBahanAdd] = useState([
    {
      idBahan: "",
      bahan: "",
      descriptionBahan: "",
      koefisienBahan: "",
      hargaBahan: "",
      purchaseUnitBahan: "",
      unitPriceIDRBahan: "",
      unitMeasurementBahan: [],
      inputUnitBahan: "",
      ukuranBahan: "",
      itemIdBahan: "",
    },
  ]);

  const [sectionsPeralatanAdd, setSectionsPeralatanAdd] = useState([
    {
      idPeralatan: "",
      peralatan: "",
      descriptionPeralatan: "",
      koefisienPeralatan: "",
      hargaPeralatan: "",
      purchaseUnitPeralatan: "",
      unitPriceIDRPeralatan: "",
      unitMeasurementPeralatan: [],
      inputUnitPeralatan: "",
      ukuranPeralatan: "",
      itemIdPeralatan: "",
    },
  ]);

  const [totalJumlahHargaTenagaKerja, setTotalJumlahHargaTenagaKerja] =
    useState(0);
  const [totalJumlahHargaBahan, setTotalJumlahHargaBahan] = useState(0);
  const [totalJumlahHargaPeralatan, setTotalJumlahHargaPeralatan] = useState(0);
  const [totalJumlahHargaABCAdd, setTotalJumlahHargaABCAdd] = useState(0);
  const [totalJumlahHargaDEAdd, setTotalJumlahHargaDEAdd] = useState(0);

  const showPopupMandatoryError = () => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: "Lengkapi data yang wajib diisi.",
    });
  };

  const validateForm = () => {
    let newErrors = {
      namaAHS: !ahsDataAdd.namaAHS,
      kategoriAHS: !ahsDataAdd.kategoriAHS,
      sumber: !ahsDataAdd.sumber,
      satuanAHS: !ahsDataAdd.satuanAHS,
      kodeAHS: !ahsDataAdd.kodeAHS,
    };

    console.log(newErrors)

    // setError(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const handleSaveAdd = async () => {
    if (!validateForm()) {
      showPopupMandatoryError();
      return
    }
    try {
      // Format data dari state untuk dikirim ke API
      const newAhsData = {
        namaAHS: ahsDataAdd.namaAHS,
        kategoriAHS: ahsDataAdd.kategoriAHS,
        satuanAHS: ahsDataAdd.satuanAHS,
        kodeAHS: ahsDataAdd.kodeAHS,
        sumber: ahsDataAdd.sumber,
        hargaSatuan: totalJumlahHargaABCAdd.toString(),
        jumlahHargaTenagaKerja: ahsDataAdd.jumlahHargaTenagaKerja,
        jumlahHargaBahan: ahsDataAdd.jumlahHargaBahan,
        jumlahHargaPeralatan: ahsDataAdd.jumlahHargaPeralatan,
        overheadProfitKoefisien: ahsDataAdd.overheadProfitKoefisien,
        jumlahOverheadProfitKoefisien: ahsDataAdd.jumlahOverheadProfitKoefisien,
        totalJumlahHargaABC: totalJumlahHargaABCAdd.toString(),
        totalJumlahHargaDE: totalJumlahHargaDEAdd.toString(),
        totalAHS: totalJumlahHargaDEAdd.toString(),
        items: [
          // Format data tenaga kerja
          ...sectionsTenagaKerjaAdd.map((item) => ({
            idTk: item.idTk,
            tenagaKerja: item.tenagaKerja,
            descriptionTenagaKerja: item.descriptionTenagaKerja,
            koefisienTenagaKerja: item.koefisienTenagaKerja,
            hargaTenagaKerja: item.hargaTenagaKerja,
            purchaseUnitTenagaKerja: item.purchaseUnitTenagaKerja,
            unitPriceIDRTenagaKerja: item.unitPriceIDRTenagaKerja,
            unitMeasurementTenagaKerja: item.unitMeasurementTenagaKerja,
            inputUnitTenagaKerja: item.inputUnitTenagaKerja,
            ukuranTenagaKerja: item.ukuranTenagaKerja,
            itemIdTk: item.itemIdTk,
          })),

          // Format data bahan
          ...sectionsBahanAdd.map((item) => ({
            idBahan: item.idBahan,
            bahan: item.bahan,
            descriptionBahan: item.descriptionBahan,
            koefisienBahan: item.koefisienBahan,
            hargaBahan: item.hargaBahan,
            purchaseUnitBahan: item.purchaseUnitBahan,
            unitPriceIDRBahan: item.unitPriceIDRBahan,
            unitMeasurementBahan: item.unitMeasurementBahan,
            inputUnitBahan: item.inputUnitBahan,
            ukuranBahan: item.ukuranBahan,
            itemIdBahan: item.itemIdBahan,
          })),

          // Format data peralatan
          ...sectionsPeralatanAdd.map((item) => ({
            idPeralatan: item.idPeralatan,
            peralatan: item.peralatan,
            descriptionPeralatan: item.descriptionPeralatan,
            koefisienPeralatan: item.koefisienPeralatan,
            hargaPeralatan: item.hargaPeralatan,
            purchaseUnitPeralatan: item.purchaseUnitPeralatan,
            unitPriceIDRPeralatan: item.unitPriceIDRPeralatan,
            unitMeasurementPeralatan: item.unitMeasurementPeralatan,
            inputUnitPeralatan: item.inputUnitPeralatan,
            ukuranPeralatan: item.ukuranPeralatan,
            itemIdPeralatan: item.itemIdPeralatan,
          })),
        ],
      };

      // Kirim data ke API
      const response = await createAhs(newAhsData);

      // Tampilkan notifikasi sukses
      Swal.fire({
        icon: "success",
        title: "AHS berhasil dibuat!",
        confirmButtonColor: "#0F62FE",
        // showConfirmButton: false,
        // timer: 1500,
      });

      // Tutup dialog dan reset form
      setOpenAddAHSDialog(false);
      resetAddForm();

      // Refresh data AHS
      reloadAHS();

      console.log("Response dari API:", response);
    } catch (error) {
      console.error("Gagal membuat AHS:", error);

      // Tampilkan notifikasi error
      Swal.fire({
        icon: "error",
        title: "Gagal membuat AHS",
        text:
          error.response?.data?.message ||
          "Terjadi kesalahan saat menyimpan data",
      });
    }
  };

  const addSectionTenagaKerjaAdd = () => {
    setSectionsTenagaKerjaAdd([
      ...sectionsTenagaKerjaAdd,
      {
        idTk: "",
        tenagaKerja: "",
        descriptionTenagaKerja: "",
        koefisienTenagaKerja: "",
        hargaTenagaKerja: "",
        purchaseUnitTenagaKerja: "",
        unitPriceIDRTenagaKerja: "",
        unitMeasurementTenagaKerja: [],
        inputUnitTenagaKerja: "",
        ukuranTenagaKerja: "",
        itemIdTk: "",
      },
    ]);
  };

  const addSectionBahanAdd = () => {
    setSectionsBahanAdd([
      ...sectionsBahanAdd,
      {
        idBahan: "",
        bahan: "",
        descriptionBahan: "",
        koefisienBahan: "",
        hargaBahan: "",
        purchaseUnitBahan: "",
        unitPriceIDRBahan: "",
        unitMeasurementBahan: [],
        inputUnitBahan: "",
        ukuranBahan: "",
        itemIdBahan: "",
      },
    ]);
  };

  const addSectionPeralatanAdd = () => {
    setSectionsPeralatanAdd([
      ...sectionsPeralatanAdd,
      {
        idPeralatan: "",
        peralatan: "",
        descriptionPeralatan: "",
        koefisienPeralatan: "",
        hargaPeralatan: "",
        purchaseUnitPeralatan: "",
        unitPriceIDRPeralatan: "",
        unitMeasurementPeralatan: [],
        inputUnitPeralatan: "",
        ukuranPeralatan: "",
        itemIdPeralatan: "",
      },
    ]);
  };

  const removeSectionTenagaKerjaAdd = (index) => {
    if (sectionsTenagaKerjaAdd.length > 1) {
      const newSectionsAdd = [...sectionsTenagaKerjaAdd];
      newSectionsAdd.splice(index, 1);
      setSectionsTenagaKerjaAdd(newSectionsAdd);
    }
  };

  const removeSectionBahanAdd = (index) => {
    if (sectionsBahanAdd.length > 1) {
      const newSectionsAdd = [...sectionsBahanAdd];
      newSectionsAdd.splice(index, 1);
      setSectionsBahanAdd(newSectionsAdd);
    }
  };

  const removeSectionPeralatanAdd = (index) => {
    if (sectionsPeralatanAdd.length > 1) {
      const newSectionsAdd = [...sectionsPeralatanAdd];
      newSectionsAdd.splice(index, 1);
      setSectionsPeralatanAdd(newSectionsAdd);
    }
  };

  // const handleChangeTenagaKerja = (index, field, value) => {
  //   const newSectionsAdd = [...sectionsTenagaKerjaAdd];
  //   newSectionsAdd[index][field] = value;
  //   setSectionsTenagaKerjaAdd(newSectionsAdd);
  // };
  const handleOpenAddDialog = () => {
    resetAddForm();
    setOpenAddAHSDialog(true);
  };

  const handleItemSelectTKAdd = async (index, selectedId) => {
    try {
      // Temukan item yang dipilih dari allItemDetailsTK
      const selectedItem = allItemDetailsTK.find(
        (item) => item.id === selectedId
      );

      if (selectedItem) {
        const updatedSections = [...sectionsTenagaKerjaAdd];
        updatedSections[index] = {
          ...updatedSections[index],
          idTk: selectedId,
          tenagaKerja: selectedItem.itemDetailName, // Simpan nama untuk display
          descriptionTenagaKerja: selectedItem.description,
          itemIdTk: selectedItem.id, // Simpan ID untuk referensi
          purchaseUnitTenagaKerja: selectedItem.purchaseUnitMeasurement,
          unitPriceIDRTenagaKerja: selectedItem.unitPrice,
          unitMeasurementTenagaKerja: selectedItem.unitMeasurement || [],
          inputUnitTenagaKerja: selectedItem.unit || "",
          ukuranTenagaKerja: selectedItem.size || "",
        };
        setSectionsTenagaKerjaAdd(updatedSections);
      }
    } catch (error) {
      console.error("Error handling item selection:", error);
    }
  };

  const handleItemSelectBahanAdd = async (index, selectedId) => {
    try {
      // Temukan item yang dipilih dari allItemDetailsBahan
      const selectedItem = allItemDetailsBahan.find(
        (item) => item.id === selectedId
      );

      if (selectedItem) {
        const updatedSections = [...sectionsBahanAdd];
        updatedSections[index] = {
          ...updatedSections[index],
          idBahan: selectedId,
          bahan: selectedItem.itemDetailName, // Simpan nama untuk display
          descriptionBahan: selectedItem.description,
          itemIdBahan: selectedItem.id, // Simpan ID untuk referensi
          purchaseUnitBahan: selectedItem.purchaseUnitMeasurement,
          unitPriceIDRBahan: selectedItem.unitPrice,
          unitMeasurementBahan: selectedItem.unitMeasurement || [],
          inputUnitBahan: selectedItem.unit || "",
          ukuranBahan: selectedItem.size || "",
        };
        setSectionsBahanAdd(updatedSections);
      }
    } catch (error) {
      console.error("Error handling item selection:", error);
    }
  };

  const handleItemSelectPeralatanAdd = async (index, selectedId) => {
    try {
      // Temukan item yang dipilih dari allItemDetailsPeralatan
      const selectedItem = allItemDetailsPeralatan.find(
        (item) => item.id === selectedId
      );

      if (selectedItem) {
        const updatedSections = [...sectionsPeralatanAdd];
        updatedSections[index] = {
          ...updatedSections[index],
          idPeralatan: selectedId,
          peralatan: selectedItem.itemDetailName, // Simpan nama untuk display
          descriptionPeralatan: selectedItem.description,
          itemIdPeralatan: selectedItem.id, // Simpan ID untuk referensi
          purchaseUnitPeralatan: selectedItem.purchaseUnitMeasurement,
          unitPriceIDRPeralatan: selectedItem.unitPrice,
          unitMeasurementPeralatan: selectedItem.unitMeasurement || [],
          inputUnitPeralatan: selectedItem.unit || "",
          ukuranPeralatan: selectedItem.size || "",
        };
        setSectionsPeralatanAdd(updatedSections);
      }
    } catch (error) {
      console.error("Error handling item selection:", error);
    }
  };

  const handleChangeTenagaKerja = (index: number, value: string) => {
    const selectedItem = categoryItemsTK.find((item) => item.name === value);

    setSectionsTenagaKerjaAdd((prevSections) => {
      const newSections = [...prevSections];
      newSections[index] = {
        ...newSections[index],
        tenagaKerja: value,
        descriptionTenagaKerja: selectedItem?.description || "",
      };
      return newSections;
    });
  };

  const handleChangeBahan = (index: number, field: string, value: string) => {
    // Temukan item yang dipilih berdasarkan name/value
    const selectedItem = categoryItemsBahan.find((item) => item.name === value);

    // Update state form
    const updatedSections = [...sectionsBahanAdd];
    updatedSections[index] = {
      ...updatedSections[index],
      [field]: value,
      descriptionBahan: selectedItem?.description || "", // Update description
    };
    setSectionsBahanAdd(updatedSections);
  };

  const handleChangePeralatan = (
    index: number,
    field: string,
    value: string
  ) => {
    // Temukan item yang dipilih berdasarkan name/value
    const selectedItem = categoryItemsPeralatan.find(
      (item) => item.name === value
    );

    // Update state form
    const updatedSections = [...sectionsPeralatanAdd];
    updatedSections[index] = {
      ...updatedSections[index],
      [field]: value,
      descriptionPeralatan: selectedItem?.description || "", // Update description
    };
    setSectionsPeralatanAdd(updatedSections);
  };

  const handleInputChangeAdd = (e) => {
    const { name, value } = e.target;
    setAhsDataAdd((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const resetAddForm = () => {
    setAhsDataAdd({
      namaAHS: "",
      kategoriAHS: "",
      satuanAHS: "",
      kodeAHS: "",
      sumber: "",
      jumlahHargaTenagaKerja: "",
      jumlahHargaBahan: "",
      jumlahHargaPeralatan: "",
      overheadProfitKoefisien: "",
      jumlahOverheadProfitKoefisien: "",
    });

    setSectionsTenagaKerjaAdd([
      {
        idTk: "",
        tenagaKerja: "",
        descriptionTenagaKerja: "",
        koefisienTenagaKerja: "",
        hargaTenagaKerja: "",
        purchaseUnitTenagaKerja: "",
        unitPriceIDRTenagaKerja: "",
        unitMeasurementTenagaKerja: [],
        inputUnitTenagaKerja: "",
        ukuranTenagaKerja: "",
        itemIdTk: "",
      },
    ]);

    setSectionsBahanAdd([
      {
        idBahan: "",
        bahan: "",
        descriptionBahan: "",
        koefisienBahan: "",
        hargaBahan: "",
        purchaseUnitBahan: "",
        unitPriceIDRBahan: "",
        unitMeasurementBahan: [],
        inputUnitBahan: "",
        ukuranBahan: "",
        itemIdBahan: "",
      },
    ]);

    setSectionsPeralatanAdd([
      {
        idPeralatan: "",
        peralatan: "",
        descriptionPeralatan: "",
        koefisienPeralatan: "",
        hargaPeralatan: "",
        purchaseUnitPeralatan: "",
        unitPriceIDRPeralatan: "",
        unitMeasurementPeralatan: [],
        inputUnitPeralatan: "",
        ukuranPeralatan: "",
        itemIdPeralatan: "",
      },
    ]);
  };

  const handleCloseAdd = () => {
    setOpenAddAHSDialog(false);
    resetAddForm(); // Reset form saat ditutup
  };

  const handleOverheadProfitChangeAdd = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    setAhsDataAdd((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "overheadProfitKoefisien" && {
        jumlahOverheadProfitKoefisien: value
          ? (parseFloat(value) * totalJumlahHargaABCAdd).toString()
          : "",
      }),
    }));
  };

  const handleKoefisienTenagaKerjaChangeAdd = (
    index: number,
    value: string
  ) => {
    const newSections = [...sectionsTenagaKerjaAdd];

    // Update koefisien
    newSections[index].koefisienTenagaKerja = value;

    // Ambil nilai unit price
    const unitPrice =
      parseFloat(newSections[index].unitPriceIDRTenagaKerja) || 0;

    // Hitung harga jika unit price ada
    if (unitPrice > 0) {
      const koefisien = parseFloat(value) || 0;
      newSections[index].hargaTenagaKerja = (koefisien * unitPrice).toString();
    } else {
      newSections[index].hargaTenagaKerja = "0";
    }

    setSectionsTenagaKerjaAdd(newSections);
  };

  const handleKoefisienBahanChangeAdd = (index: number, value: string) => {
    const newSections = [...sectionsBahanAdd];

    // Update koefisien
    newSections[index].koefisienBahan = value;

    // Ambil nilai unit price
    const unitPrice = parseFloat(newSections[index].unitPriceIDRBahan) || 0;

    // Hitung harga jika unit price ada
    if (unitPrice > 0) {
      const koefisien = parseFloat(value) || 0;
      newSections[index].hargaBahan = (koefisien * unitPrice).toString();
    } else {
      newSections[index].hargaBahan = "0";
    }

    setSectionsBahanAdd(newSections);
  };

  const handleKoefisienPeralatanChangeAdd = (index: number, value: string) => {
    const newSections = [...sectionsPeralatanAdd];

    // Update koefisien
    newSections[index].koefisienPeralatan = value;

    // Ambil nilai unit price
    const unitPrice = parseFloat(newSections[index].unitPriceIDRPeralatan) || 0;

    // Hitung harga jika unit price ada
    if (unitPrice > 0) {
      const koefisien = parseFloat(value) || 0;
      newSections[index].hargaPeralatan = (koefisien * unitPrice).toString();
    } else {
      newSections[index].hargaPeralatan = "0";
    }

    setSectionsPeralatanAdd(newSections);
  };

  // Calculate total whenever sectionsAdd changes
  useEffect(() => {
    const sumTenagaKerja = sectionsTenagaKerjaAdd.reduce((acc, section) => {
      const harga = parseFloat(section.hargaTenagaKerja) || 0;
      return acc + harga;
    }, 0);

    const sumBahan = sectionsBahanAdd.reduce((acc, section) => {
      const harga = parseFloat(section.hargaBahan) || 0;
      return acc + harga;
    }, 0);

    const sumPeralatan = sectionsPeralatanAdd.reduce((acc, section) => {
      const harga = parseFloat(section.hargaPeralatan) || 0;
      return acc + harga;
    }, 0);

    const sumABC = sumTenagaKerja + sumBahan + sumPeralatan;
    const overheadProfit =
      parseFloat(ahsDataAdd.jumlahOverheadProfitKoefisien) || 0;
    const sumDE = sumABC + overheadProfit;

    setTotalJumlahHargaABCAdd(sumABC);
    setTotalJumlahHargaDEAdd(sumDE);

    // Convert numbers to strings when updating ahsDataAdd
    setAhsDataAdd((prev) => ({
      ...prev,
      jumlahHargaTenagaKerja: sumTenagaKerja.toString(),
      jumlahHargaBahan: sumBahan.toString(),
      jumlahHargaPeralatan: sumPeralatan.toString(),
    }));
  }, [
    sectionsTenagaKerjaAdd,
    sectionsBahanAdd,
    sectionsPeralatanAdd,
    ahsDataAdd.jumlahOverheadProfitKoefisien,
  ]);

  // State untuk menyimpan semua detail items
  const [allItemDetailsTK, setAllItemDetailsTK] = useState<Array<any>>([]);
  const [allItemDetailsBahan, setAllItemDetailsBahan] = useState<Array<any>>(
    []
  );
  const [allItemDetailsPeralatan, setAllItemDetailsPeralatan] = useState<
    Array<any>
  >([]);

  // Fungsi untuk memuat semua data
  const loadAllTenagaKerjaData = async () => {
  setLoadingCategoryItemsTK(true);
  setLoadingDetailItemsTK(true);
  setLoadingCategoryItemsBahan(true);
  setLoadingDetailItemsBahan(true);
  setLoadingCategoryItemsPeralatan(true);
  setLoadingDetailItemsPeralatan(true);

  try {
    // Fetch semua item details sekali saja
    const allItemDetails = await getAllItemDetails();

    // ===== TENAGA KERJA =====
    try {
      setLoadingCategoryItemsTK(true);
      const response = await fetchTenagaKerjaItems();
      const items = Array.isArray(response) ? response : response?.data || [];

      setCategoryItemsTK(items);

      if (items.length > 0 && allItemDetails.length > 0) {
        const allTKDetails = items.flatMap((item) => {
          const details = allItemDetails.filter(
            (detail) => detail.itemId === item.id
          );
          return details.map((detail) => ({
            ...detail,
            id: detail.id,
            itemId: item.id,
            itemDetailName: detail.itemDetailName,
            itemName: item.name,
          }));
        });
        setAllItemDetailsTK(allTKDetails);
      }
    } catch (error) {
      console.error("Error loading tenaga kerja data:", error);
      setAllItemDetailsTK([]);
    } finally {
      setLoadingCategoryItemsTK(false);
    }

    // ===== BAHAN =====
    try {
      setLoadingCategoryItemsBahan(true);
      const response = await fetchBahanItems();
      const items = Array.isArray(response) ? response : response?.data || [];

      setCategoryItemsBahan(items);

      if (items.length > 0 && allItemDetails.length > 0) {
        const allBahanDetails = items.flatMap((item) => {
          const details = allItemDetails.filter(
            (detail) => detail.itemId === item.id
          );
          return details.map((detail) => ({
            ...detail,
            id: detail.id,
            itemId: item.id,
            itemDetailName: detail.itemDetailName || item.name,
          }));
        });
        setAllItemDetailsBahan(allBahanDetails);
      }
    } catch (error) {
      console.error("Error loading bahan data:", error);
      setAllItemDetailsBahan([]);
    } finally {
      setLoadingCategoryItemsBahan(false);
    }

    // ===== PERALATAN =====
    try {
      setLoadingCategoryItemsPeralatan(true);
      const response = await fetchPeralatanItems();
      const items = Array.isArray(response) ? response : response?.data || [];

      setCategoryItemsPeralatan(items);

      if (items.length > 0 && allItemDetails.length > 0) {
        const allPeralatanDetails = items.flatMap((item) => {
          const details = allItemDetails.filter(
            (detail) => detail.itemId === item.id
          );
          return details.map((detail) => ({
            ...detail,
            id: detail.id,
            itemId: item.id,
            itemDetailName: detail.itemDetailName || item.name,
          }));
        });
        setAllItemDetailsPeralatan(allPeralatanDetails);
      }
    } catch (error) {
      console.error("Error loading peralatan data:", error);
      setAllItemDetailsPeralatan([]);
    } finally {
      setLoadingCategoryItemsPeralatan(false);
    }
  } catch (error) {
    console.error("Error loading all item details:", error);
    setAllItemDetailsTK([]);
    setAllItemDetailsBahan([]);
    setAllItemDetailsPeralatan([]);
  }
};

  // Panggil fungsi load
  useEffect(() => {
    loadAllTenagaKerjaData();
  }, []);

  //edit ahs data ========================================================================

  const [isEditing, setIsEditing] = useState(false);
  const [ahsDataEdit, setAhsDataEdit] = useState({
    id: "",
    namaAHS: "",
    kategoriAHS: "",
    satuanAHS: "",
    kodeAHS: "",
    sumber: "",
    jumlahHargaTenagaKerja: "",
    jumlahHargaBahan: "",
    jumlahHargaPeralatan: "",
    overheadProfitKoefisien: "",
    jumlahOverheadProfitKoefisien: "",
  });

  const [sectionsTenagaKerjaEdit, setSectionsTenagaKerjaEdit] = useState([
    {
      idTk: "",
      tenagaKerja: "",
      descriptionTenagaKerja: "",
      koefisienTenagaKerja: "",
      hargaTenagaKerja: "",
      purchaseUnitTenagaKerja: "",
      unitPriceIDRTenagaKerja: "",
      unitMeasurementTenagaKerja: [],
      inputUnitTenagaKerja: "",
      ukuranTenagaKerja: "",
      itemIdTk: "",
    },
  ]);

  const [sectionsBahanEdit, setSectionsBahanEdit] = useState([
    {
      idBahan: "",
      bahan: "",
      descriptionBahan: "",
      koefisienBahan: "",
      hargaBahan: "",
      purchaseUnitBahan: "",
      unitPriceIDRBahan: "",
      unitMeasurementBahan: [],
      inputUnitBahan: "",
      ukuranBahan: "",
      itemIdBahan: "",
    },
  ]);

  const [sectionsPeralatanEdit, setSectionsPeralatanEdit] = useState([
    {
      idPeralatan: "",
      peralatan: "",
      descriptionPeralatan: "",
      koefisienPeralatan: "",
      hargaPeralatan: "",
      purchaseUnitPeralatan: "",
      unitPriceIDRPeralatan: "",
      unitMeasurementPeralatan: [],
      inputUnitPeralatan: "",
      ukuranPeralatan: "",
      itemIdPeralatan: "",
    },
  ]);

  const [totalJumlahHargaABCEdit, setTotalJumlahHargaABCEdit] = useState(0);
  const [totalJumlahHargaDEEdit, setTotalJumlahHargaDEEdit] = useState(0);

  // Helper function to safely parse potentially double-encoded JSON
  const safeJSONParse = (value, defaultValue = []) => {
    if (!value) return defaultValue;
    if (typeof value !== 'string') return value;
    
    try {
      let parsed = JSON.parse(value);
      // Check if it's still a string (double-encoded)
      while (typeof parsed === 'string') {
        parsed = JSON.parse(parsed);
      }
      return parsed;
    } catch (error) {
      console.error("Failed to parse JSON:", error, "Value:", value);
      return defaultValue;
    }
  };

  const handleOpenEditDialog = async (ahs) => {
    try {
      setIsLoading(true);
      
      // Fetch full AHS data with items
      const ahsDetail = await getAhsById(ahs.id);
      
      // Parse items if it's a string
      let items = ahsDetail.items;
      if (typeof items === 'string') {
        try {
          items = JSON.parse(items);
        } catch (parseError) {
          console.error("Failed to parse items JSON:", parseError);
          throw new Error("Data AHS tidak valid. Format items tidak sesuai.");
        }
      }
      
      // Ensure items is an array
      if (!Array.isArray(items)) {
        console.error("Items is not an array:", items);
        items = [];
      }
      
      // Initialize the main AHS data
      setAhsDataEdit({
        id: ahsDetail.id,
        namaAHS: ahsDetail.namaAHS,
        kategoriAHS: ahsDetail.category,
        satuanAHS: ahsDetail.satuanAHS,
        kodeAHS: ahsDetail.ahsSubCode,
        sumber: ahsDetail.sumber,
        jumlahHargaTenagaKerja: ahsDetail.jumlahHargaTenagaKerja || "0",
        jumlahHargaBahan: ahsDetail.jumlahHargaBahan || "0",
        jumlahHargaPeralatan: ahsDetail.jumlahHargaPeralatan || "0",
        overheadProfitKoefisien: ahsDetail.overheadKoefisien || "0",
        jumlahOverheadProfitKoefisien: ahsDetail.jumlahOverheadProfitKoefisien || "0",
      });

      // Separate items into their respective sections
      const tenagaKerjaItems = items.filter((item) => item.tenagaKerja);
      const bahanItems = items.filter((item) => item.bahan);
      const peralatanItems = items.filter((item) => item.peralatan);

      // Format the items for each section
      const formattedTenagaKerja = tenagaKerjaItems.map((item) => ({
        idTk: item.idTk || "",
        tenagaKerja: item.tenagaKerja,
        descriptionTenagaKerja: item.descriptionTenagaKerja,
        koefisienTenagaKerja: item.koefisienTenagaKerja,
        hargaTenagaKerja: item.hargaTenagaKerja,
        purchaseUnitTenagaKerja: item.purchaseUnitTenagaKerja,
        unitPriceIDRTenagaKerja:
          item.unitPriceIDRTenagaKerja?.toString() || "0",
        unitMeasurementTenagaKerja: safeJSONParse(item.unitMeasurementTenagaKerja, []),
        inputUnitTenagaKerja: item.inputUnitTenagaKerja,
        ukuranTenagaKerja: item.ukuranTenagaKerja,
        itemIdTk: item.itemIdTk || "",
      }));

      const formattedBahan = bahanItems.map((item) => ({
        idBahan: item.idBahan || "",
        bahan: item.bahan,
        descriptionBahan: item.descriptionBahan,
        koefisienBahan: item.koefisienBahan,
        hargaBahan: item.hargaBahan,
        purchaseUnitBahan: item.purchaseUnitBahan,
        unitPriceIDRBahan: item.unitPriceIDRBahan?.toString() || "0",
        unitMeasurementBahan: safeJSONParse(item.unitMeasurementBahan, []),
        inputUnitBahan: item.inputUnitBahan,
        ukuranBahan: item.ukuranBahan,
        itemIdBahan: item.itemIdBahan || "",
      }));

      const formattedPeralatan = peralatanItems.map((item) => ({
        idPeralatan: item.idPeralatan || "",
        peralatan: item.peralatan,
        descriptionPeralatan: item.descriptionPeralatan,
        koefisienPeralatan: item.koefisienPeralatan,
        hargaPeralatan: item.hargaPeralatan,
        purchaseUnitPeralatan: item.purchaseUnitPeralatan,
        unitPriceIDRPeralatan: item.unitPriceIDRPeralatan?.toString() || "0",
        unitMeasurementPeralatan: safeJSONParse(item.unitMeasurementPeralatan, []),
        inputUnitPeralatan: item.inputUnitPeralatan,
        ukuranPeralatan: item.ukuranPeralatan,
        itemIdPeralatan: item.itemIdPeralatan || "",
      }));

      // Set the sections
      setSectionsTenagaKerjaEdit(
        formattedTenagaKerja.length
          ? formattedTenagaKerja
          : [
            {
              idTk: "",
              tenagaKerja: "",
              descriptionTenagaKerja: "",
              koefisienTenagaKerja: "",
              hargaTenagaKerja: "",
              purchaseUnitTenagaKerja: "",
              unitPriceIDRTenagaKerja: "",
              unitMeasurementTenagaKerja: [],
              inputUnitTenagaKerja: "",
              ukuranTenagaKerja: "",
              itemIdTk: "",
            },
          ]
      );

      setSectionsBahanEdit(
        formattedBahan.length
          ? formattedBahan
          : [
            {
              idBahan: "",
              bahan: "",
              descriptionBahan: "",
              koefisienBahan: "",
              hargaBahan: "",
              purchaseUnitBahan: "",
              unitPriceIDRBahan: "",
              unitMeasurementBahan: [],
              inputUnitBahan: "",
              ukuranBahan: "",
              itemIdBahan: "",
            },
          ]
      );

      setSectionsPeralatanEdit(
        formattedPeralatan.length
          ? formattedPeralatan
          : [
            {
              idPeralatan: "",
              peralatan: "",
              descriptionPeralatan: "",
              koefisienPeralatan: "",
              hargaPeralatan: "",
              purchaseUnitPeralatan: "",
              unitPriceIDRPeralatan: "",
              unitMeasurementPeralatan: [],
              inputUnitPeralatan: "",
              ukuranPeralatan: "",
              itemIdPeralatan: "",
            },
          ]
      );

      // Calculate totals
      const totalABC =
        parseFloat(ahsDetail.totalJumlahHargaABC || "0") ||
        parseFloat(ahsDetail.jumlahHargaTenagaKerja || "0") +
        parseFloat(ahsDetail.jumlahHargaBahan || "0") +
        parseFloat(ahsDetail.jumlahHargaPeralatan || "0");

      const totalDE =
        parseFloat(ahsDetail.totalJumlahHargaDE || "0") ||
        totalABC + parseFloat(ahsDetail.jumlahOverheadProfitKoefisien || "0");

      setTotalJumlahHargaABCEdit(totalABC);
      setTotalJumlahHargaDEEdit(totalDE);

      setOpenEditAHSDialog(true);
      setIsEditing(false);
    } catch (error) {
      console.error("Failed to fetch ahs data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal Memuat Ahs",
        text: error.message || "Data ahs tidak ditemukan",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const validateFormEdit = () => {
    let newErrors = {
      namaAHS: !ahsDataEdit.namaAHS,
      kategoriAHS: !ahsDataEdit.kategoriAHS,
      sumber: !ahsDataEdit.sumber,
      satuanAHS: !ahsDataEdit.satuanAHS,
      kodeAHS: !ahsDataEdit.kodeAHS,
    };

    console.log(newErrors)

    // setError(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const handleSaveEdit = async () => {
    if (!validateFormEdit()) {
      showPopupMandatoryError();
      return
    }
    try {
      // Calculate totals
      const totalTenagaKerja = sectionsTenagaKerjaEdit.reduce(
        (sum, item) => sum + (parseFloat(item.hargaTenagaKerja) || 0),
        0
      );
      const totalBahan = sectionsBahanEdit.reduce(
        (sum, item) => sum + (parseFloat(item.hargaBahan) || 0),
        0
      );
      const totalPeralatan = sectionsPeralatanEdit.reduce(
        (sum, item) => sum + (parseFloat(item.hargaPeralatan) || 0),
        0
      );

      const totalABC = totalTenagaKerja + totalBahan + totalPeralatan;
      const overheadProfit =
        parseFloat(ahsDataEdit.overheadProfitKoefisien) || 0;
      const jumlahOverheadProfit = totalABC * overheadProfit;
      const totalDE = totalABC + jumlahOverheadProfit;

      // Format data for API
      const newAhsData = {
        id: ahsDataEdit.id, // Make sure this is set when opening the dialog
        namaAHS: ahsDataEdit.namaAHS,
        kategoriAHS: ahsDataEdit.kategoriAHS,
        satuanAHS: ahsDataEdit.satuanAHS,
        kodeAHS: ahsDataEdit.kodeAHS,
        sumber: ahsDataEdit.sumber,
        hargaSatuan: totalABC.toString(),
        jumlahHargaTenagaKerja: totalTenagaKerja.toString(),
        jumlahHargaBahan: totalBahan.toString(),
        jumlahHargaPeralatan: totalPeralatan.toString(),
        overheadProfitKoefisien: ahsDataEdit.overheadProfitKoefisien,
        jumlahOverheadProfitKoefisien: jumlahOverheadProfit.toString(),
        totalJumlahHargaABC: totalABC.toString(),
        totalJumlahHargaDE: totalDE.toString(),
        totalAHS: totalDE.toString(),
        items: [
          // Format data tenaga kerja
          ...sectionsTenagaKerjaEdit.map((item) => ({
            idTk: item.idTk,
            tenagaKerja: item.tenagaKerja,
            descriptionTenagaKerja: item.descriptionTenagaKerja,
            koefisienTenagaKerja: item.koefisienTenagaKerja,
            hargaTenagaKerja: item.hargaTenagaKerja,
            purchaseUnitTenagaKerja: item.purchaseUnitTenagaKerja,
            unitPriceIDRTenagaKerja: item.unitPriceIDRTenagaKerja,
            unitMeasurementTenagaKerja: item.unitMeasurementTenagaKerja,
            inputUnitTenagaKerja: item.inputUnitTenagaKerja,
            ukuranTenagaKerja: item.ukuranTenagaKerja,
            itemId: item.itemIdTk,
          })),

          // Format data bahan
          ...sectionsBahanEdit.map((item) => ({
            idBahan: item.idBahan,
            bahan: item.bahan,
            descriptionBahan: item.descriptionBahan,
            koefisienBahan: item.koefisienBahan,
            hargaBahan: item.hargaBahan,
            purchaseUnitBahan: item.purchaseUnitBahan,
            unitPriceIDRBahan: item.unitPriceIDRBahan,
            unitMeasurementBahan: item.unitMeasurementBahan,
            inputUnitBahan: item.inputUnitBahan,
            ukuranBahan: item.ukuranBahan,
            itemId: item.itemIdBahan,
          })),

          // Format data peralatan
          ...sectionsPeralatanEdit.map((item) => ({
            idPeralatan: item.idPeralatan,
            peralatan: item.peralatan,
            descriptionPeralatan: item.descriptionPeralatan,
            koefisienPeralatan: item.koefisienPeralatan,
            hargaPeralatan: item.hargaPeralatan,
            purchaseUnitPeralatan: item.purchaseUnitPeralatan,
            unitPriceIDRPeralatan: item.unitPriceIDRPeralatan,
            unitMeasurementPeralatan: item.unitMeasurementPeralatan,
            inputUnitPeralatan: item.inputUnitPeralatan,
            ukuranPeralatan: item.ukuranPeralatan,
            itemId: item.itemIdPeralatan,
          })),
        ],
      };

      // Kirim data ke API
      const response = await updateAhs(newAhsData);

      // Tampilkan notifikasi sukses
      Swal.fire({
        icon: "success",
        title: "AHS berhasil diupdate!",
        confirmButtonColor: "#0F62FE",
        // showConfirmButton: false,
        // timer: 1500,
      });

      // Tutup dialog dan reset form
      setOpenEditAHSDialog(false);
      resetEditForm();

      // Refresh data AHS
      reloadAHS();

      console.log("Response dari API:", response);
    } catch (error) {
      console.error("Gagal mengupdate AHS:", error);

      // Tampilkan notifikasi error
      Swal.fire({
        icon: "error",
        title: "Gagal mengupdate AHS",
        text:
          error.response?.data?.message ||
          "Terjadi kesalahan saat menyimpan data",
      });
    }
  };

  const resetEditForm = () => {
    setAhsDataEdit({
      id: "",
      namaAHS: "",
      kategoriAHS: "",
      satuanAHS: "",
      kodeAHS: "",
      sumber: "",
      jumlahHargaTenagaKerja: "",
      jumlahHargaBahan: "",
      jumlahHargaPeralatan: "",
      overheadProfitKoefisien: "",
      jumlahOverheadProfitKoefisien: "",
    });

    setSectionsTenagaKerjaEdit([
      {
        idTk: "",
        tenagaKerja: "",
        descriptionTenagaKerja: "",
        koefisienTenagaKerja: "",
        hargaTenagaKerja: "",
        purchaseUnitTenagaKerja: "",
        unitPriceIDRTenagaKerja: "",
        unitMeasurementTenagaKerja: [],
        inputUnitTenagaKerja: "",
        ukuranTenagaKerja: "",
        itemIdTk: "",
      },
    ]);

    setSectionsBahanEdit([
      {
        idBahan: "",
        bahan: "",
        descriptionBahan: "",
        koefisienBahan: "",
        hargaBahan: "",
        purchaseUnitBahan: "",
        unitPriceIDRBahan: "",
        unitMeasurementBahan: [],
        inputUnitBahan: "",
        ukuranBahan: "",
        itemIdBahan: "",
      },
    ]);

    setSectionsPeralatanEdit([
      {
        idPeralatan: "",
        peralatan: "",
        descriptionPeralatan: "",
        koefisienPeralatan: "",
        hargaPeralatan: "",
        purchaseUnitPeralatan: "",
        unitPriceIDRPeralatan: "",
        unitMeasurementPeralatan: [],
        inputUnitPeralatan: "",
        ukuranPeralatan: "",
        itemIdPeralatan: "",
      },
    ]);
  };

  const handleCloseEdit = () => {
    setOpenEditAHSDialog(false);
    resetEditForm(); // Reset form saat ditutup
    setIsEditing(false);
  };

  const addSectionTenagaKerjaEdit = () => {
    setSectionsTenagaKerjaEdit([
      ...sectionsTenagaKerjaEdit,
      {
        idTk: "",
        tenagaKerja: "",
        descriptionTenagaKerja: "",
        koefisienTenagaKerja: "",
        hargaTenagaKerja: "",
        purchaseUnitTenagaKerja: "",
        unitPriceIDRTenagaKerja: "",
        unitMeasurementTenagaKerja: [],
        inputUnitTenagaKerja: "",
        ukuranTenagaKerja: "",
        itemIdTk: "",
      },
    ]);
  };

  const addSectionBahanEdit = () => {
    setSectionsBahanEdit([
      ...sectionsBahanEdit,
      {
        idBahan: "",
        bahan: "",
        descriptionBahan: "",
        koefisienBahan: "",
        hargaBahan: "",
        purchaseUnitBahan: "",
        unitPriceIDRBahan: "",
        unitMeasurementBahan: [],
        inputUnitBahan: "",
        ukuranBahan: "",
        itemIdBahan: "",
      },
    ]);
  };

  const addSectionPeralatanEdit = () => {
    setSectionsPeralatanEdit([
      ...sectionsPeralatanEdit,
      {
        idPeralatan: "",
        peralatan: "",
        descriptionPeralatan: "",
        koefisienPeralatan: "",
        hargaPeralatan: "",
        purchaseUnitPeralatan: "",
        unitPriceIDRPeralatan: "",
        unitMeasurementPeralatan: [],
        inputUnitPeralatan: "",
        ukuranPeralatan: "",
        itemIdPeralatan: "",
      },
    ]);
  };

  const removeSectionTenagaKerjaEdit = (index) => {
    if (sectionsTenagaKerjaEdit.length > 1) {
      const newSectionsEdit = [...sectionsTenagaKerjaEdit];
      newSectionsEdit.splice(index, 1);
      setSectionsTenagaKerjaEdit(newSectionsEdit);
    }
  };

  const removeSectionBahanEdit = (index) => {
    if (sectionsBahanEdit.length > 1) {
      const newSectionsEdit = [...sectionsBahanEdit];
      newSectionsEdit.splice(index, 1);
      setSectionsBahanEdit(newSectionsEdit);
    }
  };

  const removeSectionPeralatanEdit = (index) => {
    if (sectionsPeralatanEdit.length > 1) {
      const newSectionsEdit = [...sectionsPeralatanEdit];
      newSectionsEdit.splice(index, 1);
      setSectionsPeralatanEdit(newSectionsEdit);
    }
  };

  const handleInputChangeEdit = (e) => {
    const { name, value } = e.target;
    setAhsDataEdit((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleItemSelectTKEdit = async (index, selectedId) => {
    console.log("data edit", sectionsTenagaKerjaEdit);
    try {
      const selectedItem = allItemDetailsTK.find(
        (item) => item.id === selectedId
      );

      if (selectedItem) {
        const updatedSections = [...sectionsTenagaKerjaEdit];
        updatedSections[index] = {
          ...updatedSections[index],
          idTk: selectedId,
          tenagaKerja: selectedItem.itemDetailName,
          descriptionTenagaKerja: selectedItem.description,
          itemIdTk: selectedItem.itemId,
          purchaseUnitTenagaKerja: selectedItem.purchaseUnitMeasurement,
          unitPriceIDRTenagaKerja: selectedItem.unitPrice?.toString() || "0",
          unitMeasurementTenagaKerja: selectedItem.unitMeasurement || [],
          inputUnitTenagaKerja: selectedItem.unit || "",
          ukuranTenagaKerja: selectedItem.size || "",
          // Recalculate harga if koefisien exists
          hargaTenagaKerja: updatedSections[index].koefisienTenagaKerja
            ? (
              parseFloat(updatedSections[index].koefisienTenagaKerja) *
              parseFloat(selectedItem.unitPrice || "0")
            ).toString()
            : "0",
        };
        setSectionsTenagaKerjaEdit(updatedSections);
      }
    } catch (error) {
      console.error("Error handling item selection:", error);
    }
  };

  const handleItemSelectBahanEdit = async (index, selectedId) => {
    try {
      const selectedItem = allItemDetailsBahan.find(
        (item) => item.id === selectedId
      );

      if (selectedItem) {
        const updatedSections = [...sectionsBahanEdit];
        updatedSections[index] = {
          ...updatedSections[index],
          idBahan: selectedId,
          bahan: selectedItem.itemDetailName,
          descriptionBahan: selectedItem.description,
          itemIdBahan: selectedItem.itemId,
          purchaseUnitBahan: selectedItem.purchaseUnitMeasurement,
          unitPriceIDRBahan: selectedItem.unitPrice?.toString() || "0",
          unitMeasurementBahan: selectedItem.unitMeasurement || [],
          inputUnitBahan: selectedItem.unit || "",
          ukuranBahan: selectedItem.size || "",
          // Recalculate harga if koefisien exists
          hargaBahan: updatedSections[index].koefisienBahan
            ? (
              parseFloat(updatedSections[index].koefisienBahan) *
              parseFloat(selectedItem.unitPrice || "0")
            ).toString()
            : "0",
        };
        setSectionsBahanEdit(updatedSections);
      }
    } catch (error) {
      console.error("Error handling item selection:", error);
    }
  };

  const handleItemSelectPeralatanEdit = async (index, selectedId) => {
    try {
      const selectedItem = allItemDetailsPeralatan.find(
        (item) => item.id === selectedId
      );

      if (selectedItem) {
        const updatedSections = [...sectionsPeralatanEdit];
        updatedSections[index] = {
          ...updatedSections[index],
          idPeralatan: selectedId,
          peralatan: selectedItem.itemDetailName,
          descriptionPeralatan: selectedItem.description,
          itemIdPeralatan: selectedItem.itemId,
          purchaseUnitPeralatan: selectedItem.purchaseUnitMeasurement,
          unitPriceIDRPeralatan: selectedItem.unitPrice?.toString() || "0",
          unitMeasurementPeralatan: selectedItem.unitMeasurement || [],
          inputUnitPeralatan: selectedItem.unit || "",
          ukuranPeralatan: selectedItem.size || "",
          // Recalculate harga if koefisien exists
          hargaPeralatan: updatedSections[index].koefisienPeralatan
            ? (
              parseFloat(updatedSections[index].koefisienPeralatan) *
              parseFloat(selectedItem.unitPrice || "0")
            ).toString()
            : "0",
        };
        setSectionsPeralatanEdit(updatedSections);
      }
    } catch (error) {
      console.error("Error handling item selection:", error);
    }
  };

  const handleOverheadProfitChangeEdit = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    setAhsDataEdit((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "overheadProfitKoefisien" && {
        jumlahOverheadProfitKoefisien: value
          ? (parseFloat(value) * totalJumlahHargaABCEdit).toString()
          : "",
      }),
    }));
  };

  const handleKoefisienTenagaKerjaChangeEdit = (
    index: number,
    value: string
  ) => {
    const newSections = [...sectionsTenagaKerjaEdit];

    // Update koefisien
    newSections[index].koefisienTenagaKerja = value;

    // Ambil nilai unit price
    const unitPrice =
      parseFloat(newSections[index].unitPriceIDRTenagaKerja) || 0;

    // Hitung harga jika unit price ada
    if (unitPrice > 0) {
      const koefisien = parseFloat(value) || 0;
      newSections[index].hargaTenagaKerja = (koefisien * unitPrice).toString();
    } else {
      newSections[index].hargaTenagaKerja = "0";
    }

    setSectionsTenagaKerjaEdit(newSections);
  };

  const handleKoefisienBahanChangeEdit = (index: number, value: string) => {
    const newSections = [...sectionsBahanEdit];

    // Update koefisien
    newSections[index].koefisienBahan = value;

    // Ambil nilai unit price
    const unitPrice = parseFloat(newSections[index].unitPriceIDRBahan) || 0;

    // Hitung harga jika unit price ada
    if (unitPrice > 0) {
      const koefisien = parseFloat(value) || 0;
      newSections[index].hargaBahan = (koefisien * unitPrice).toString();
    } else {
      newSections[index].hargaBahan = "0";
    }

    setSectionsBahanEdit(newSections);
  };

  const handleKoefisienPeralatanChangeEdit = (index: number, value: string) => {
    const newSections = [...sectionsPeralatanEdit];

    // Update koefisien
    newSections[index].koefisienPeralatan = value;

    // Ambil nilai unit price
    const unitPrice = parseFloat(newSections[index].unitPriceIDRPeralatan) || 0;

    // Hitung harga jika unit price ada
    if (unitPrice > 0) {
      const koefisien = parseFloat(value) || 0;
      newSections[index].hargaPeralatan = (koefisien * unitPrice).toString();
    } else {
      newSections[index].hargaPeralatan = "0";
    }

    setSectionsPeralatanEdit(newSections);
  };

  useEffect(() => {
    // Hitung ulang total tenaga kerja
    const totalTK = sectionsTenagaKerjaEdit.reduce(
      (sum, item) => sum + (parseFloat(item.hargaTenagaKerja) || 0),
      0
    );

    // Hitung ulang total bahan
    const totalBahan = sectionsBahanEdit.reduce(
      (sum, item) => sum + (parseFloat(item.hargaBahan) || 0),
      0
    );

    // Hitung ulang total peralatan
    const totalPeralatan = sectionsPeralatanEdit.reduce(
      (sum, item) => sum + (parseFloat(item.hargaPeralatan) || 0),
      0
    );

    const totalABC = totalTK + totalBahan + totalPeralatan;
    const overhead = parseFloat(ahsDataEdit.overheadProfitKoefisien) || 0;
    const jumlahOverhead = totalABC * overhead;
    const totalDE = totalABC + jumlahOverhead;

    // Update state
    setAhsDataEdit((prev) => ({
      ...prev,
      jumlahHargaTenagaKerja: totalTK.toString(),
      jumlahHargaBahan: totalBahan.toString(),
      jumlahHargaPeralatan: totalPeralatan.toString(),
      jumlahOverheadProfitKoefisien: jumlahOverhead.toString(),
    }));

    setTotalJumlahHargaABCEdit(totalABC);
    setTotalJumlahHargaDEEdit(totalDE);
  }, [
    sectionsTenagaKerjaEdit,
    sectionsBahanEdit,
    sectionsPeralatanEdit,
    ahsDataEdit.overheadProfitKoefisien,
  ]);

  // ======================================== end of function ========================================================
  // ============================================ start ui ===========================================================

  return isLoading ? (
    <LoadingOverlay />
  ) : (
    <Box sx={{ padding: 3 }}>
      {/* Header & Tabs */}
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}
      >
        <Typography variant="h6" fontWeight="bold">
          AHS List
        </Typography>
      </Box>

      {/* Toolbar */}
      <Box className="toolbar">
        {/* Left Controls */}
        <Box className="leftControls">
          <Typography>Show</Typography>
          <Select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // reset ke halaman 1 saat ganti limit
            }}
            size="small"
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>

          {/* Search Button & Input */}
          <Button
            variant="contained"
            startIcon={<Search />}
            onClick={() => setShowSearch((prev) => !prev)}
            className="searchButton"
          >
            Search
          </Button>
          {showSearch && (
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search"
              value={searchQuery}
              onChange={async (e) => {
                await setSearchQuery(e.target.value);
              }}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
              autoFocus
              className="searchInput"
            />
          )}

          {/* Menampilkan Error */}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </Box>

        {/* Right Controls */}
        <Box className="rightControls">
          <Button
            startIcon={<Delete />}
            variant="text"
            onClick={() => handleDeleteRows()} // Pindahkan fungsi delete di sini
            disabled={selectedRows.length === 0} // Disable jika tidak ada baris yang dipilih
          >
            Delete
          </Button>

          {/* Filter Button */}
          <Button
            startIcon={<FilterList />}
            variant="text"
            onClick={() => setOpenFilterDialog(true)}
          >
            Filters
          </Button>

          <Button
            startIcon={<Download />}
            variant="contained"
            className="exportButton"
            onClick={handleExportExcel}
          >
            Export Excel
          </Button>

          <Button
            startIcon={<Add />}
            variant="contained"
            className="addCategoryButton"
            onClick={handleOpenAddDialog} // Ganti dari setOpenAddEmployeeDialog
          >
            Add New Analisa Harga Satuan
          </Button>
        </Box>
      </Box>

      <Box className="deleteContainer">
        <Typography variant="body2" className="detailsSubtitle">
          Details List Of AHS
        </Typography>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} className="tableContainer">
        <Table className="table">
          <TableHead className="tableHead">
            <TableRow>
              <TableCell padding="checkbox" className="tableCell">
                <Checkbox
                  indeterminate={
                    selectedRows.length > 0 && selectedRows.length < rows.length
                  }
                  checked={selectedRows.length === rows.length}
                  onChange={() =>
                    setSelectedRows(
                      selectedRows.length === rows.length
                        ? []
                        : rows.map((row) => row.id)
                    )
                  }
                />
              </TableCell>
              <TableCell className="tableCell" width="50px">
                <strong>No</strong>
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("namaAHS")}
                style={{ cursor: "pointer" }}
              >
                <strong>AHS Name</strong>
                {sortConfig.orderBy === "namaAHS" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("ahsSubCode")}
                style={{ cursor: "pointer" }}
              >
                <strong>Kode</strong>
                {sortConfig.orderBy === "ahsSubCode" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("category")}
                style={{ cursor: "pointer" }}
              >
                <strong>AHS Category</strong>
                {sortConfig.orderBy === "category" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("sumber")}
                style={{ cursor: "pointer" }}
              >
                <strong>Sumber</strong>
                {sortConfig.orderBy === "sumber" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("totalAHS")}
                style={{ cursor: "pointer" }}
              >
                <strong>Harga Satuan Pekerjaan</strong>
                {sortConfig.orderBy === "totalAHS" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={9} align="center" style={{ color: "red" }}>
                  {error}
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, index) => (
                <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={(event) => {
                        event.stopPropagation();
                        handleSelectRow(row.id);
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    {/* Nomor urut disesuaikan dengan pagination */}
                    {offset + index + 1}
                  </TableCell>
                  <TableCell>
                    <strong>{row.namaAHS}</strong>
                  </TableCell>
                  <TableCell>{row.ahsSubCode}</TableCell>
                  <TableCell>{row.category}</TableCell>
                  <TableCell>{row.sumber}</TableCell>
                  <TableCell>
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      minimumFractionDigits: 0,
                    }).format(parseFloat(row.totalJumlahHargaDE))}
                  </TableCell>
                  {/* {row.totalJumlahHargaDE}</TableCell> */}
                  <TableCell>
                    <IconButton title="Edit" onClick={() => handleOpenEditDialog(row)}>
                      <MoreVert />
                    </IconButton>
                    <IconButton title="Duplikasi" onClick={() => handleDuplicate(row.id, row.namaAHS)}>
                      <FileCopy />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box
        className="paginationContainer"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "16px 0",
        }}
      >
        {/* Info jumlah data */}
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {`Showing ${offset + 1} to ${Math.min(
            offset + rowsPerPage,
            totalItems
          )} of ${totalItems} entries`}
        </Typography>

        {/* Komponen Pagination */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(e, page) => setCurrentPage(page)}
          className="pagination"
          showFirstButton
          showLastButton
          renderItem={(item) => (
            <PaginationItem
              {...item}
              components={{ first: FirstPage, last: LastPage }}
            />
          )}
        />
      </Box>

      {/* ======================= Filter Dialog ============================= */}
      <Dialog
        open={openFilterDialog}
        onClose={() => setOpenFilterDialog(false)}
      >
        <DialogTitle>Advanced Search</DialogTitle>
        <DialogContent>
          {filters.map((filter, index) => {
            const usedFields = filters
              .map((f, i) => i !== index && f.field)
              .filter(Boolean);
            const availableOptions = availableFilters.filter(
              (opt) => !usedFields.includes(opt.value)
            );

            const sumberOptions = ["Manual Survey", "PUPR"];

            return (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                gap={1}
                mb={2}
              >
                <TextField
                  select
                  value={filter.field}
                  onChange={(e) =>
                    handleFilterChange(index, "field", e.target.value)
                  }
                  variant="outlined"
                  size="small"
                  sx={{ mt: 1, minWidth: 160 }}
                >
                  {availableOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                {/* Render input berdasarkan jenis field */}
                {(() => {
                  if (filter.field === "category") {
                    return (
                      <Autocomplete
                        options={kategoriOptions}
                        getOptionLabel={(option) => option.label || ""}
                        value={
                          kategoriOptions.find(
                            (opt) => opt.label === filter.value
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          const newFilters = [...filters];
                          newFilters[index].value = newValue?.label || "";
                          setFilters(newFilters);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="AHS Category"
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1, minWidth: 200 }}
                          />
                        )}
                      />
                    );
                  } else if (filter.field === "sumber") {
                    return (
                      <TextField
                        select
                        label="Sumber"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1, minWidth: 160 }}
                      >
                        {sumberOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option.replace("_", " ")}
                          </MenuItem>
                        ))}
                      </TextField>
                    );
                  } else {
                    return (
                      <TextField
                        label="Value"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                    );
                  }
                })()}

                {index > 0 && (
                  <IconButton onClick={() => handleRemoveFilter(index)}>
                    <Remove />
                  </IconButton>
                )}
              </Box>
            );
          })}

          {filters.length < availableFilters.length && (
            <Button startIcon={<Add />} onClick={handleAddFilter}>
              Add Filter
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResetFilters}>Reset Filter</Button>
          <Button onClick={handleCloseFilter}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleApplyFilters}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Apply"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================== POPUP Add New AHS =========================== */}
      <Dialog
        open={openAddAHSDialog}
        onClose={() => setOpenAddAHSDialog(false)}
        fullWidth
        maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Analisis Harga Satuan (AHS)
          </Typography>
          <IconButton onClick={handleCloseAdd} color="error">
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              {/* Header section */}
              <Box sx={{ p: 2, borderBottom: "1px solid #e0e0e0" }}>
                <TextField
                  label="Nama AHS"
                  fullWidth
                  value={ahsDataAdd.namaAHS}
                  onChange={handleInputChangeAdd}
                  name="namaAHS"
                  sx={{ mb: 1 }}
                  error={!ahsDataAdd.namaAHS}
                  helperText={!ahsDataAdd.namaAHS ? "Mandatory Field" : ""}
                />
                <Autocomplete
                  options={kategoriOptions.map((option) => option.label)} // Shows labels in dropdown
                  value={ahsDataAdd.kategoriAHS || null}
                  onChange={(event, newValue) => {
                    handleInputChangeAdd({
                      target: {
                        name: "kategoriAHS",
                        value: newValue || "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Kategori AHS"
                      placeholder="Select Kategori"
                      fullWidth
                      sx={{ mb: 1 }}
                      error={!ahsDataAdd.kategoriAHS}
                      helperText={
                        !ahsDataAdd.kategoriAHS ? "Mandatory Field" : ""
                      }
                    />
                  )}
                  noOptionsText="No categories available"
                />
                <TextField
                  select
                  label="Sumber"
                  fullWidth
                  value={ahsDataAdd.sumber}
                  onChange={handleInputChangeAdd}
                  name="sumber"
                  error={!ahsDataAdd.sumber}
                  helperText={!ahsDataAdd.sumber ? "Mandatory Field" : ""}
                >
                  {sumberOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              {/* Header section */}
              <Box sx={{ p: 2, borderBottom: "1px solid #e0e0e0" }}>
                <TextField
                  label="Satuan AHS"
                  fullWidth
                  value={ahsDataAdd.satuanAHS}
                  onChange={handleInputChangeAdd}
                  name="satuanAHS"
                  sx={{ mb: 1 }}
                  error={!ahsDataAdd.satuanAHS}
                  helperText={!ahsDataAdd.satuanAHS ? "Mandatory Field" : ""}
                />
                <TextField
                  label="Kode AHS"
                  fullWidth
                  value={ahsDataAdd.kodeAHS}
                  onChange={handleInputChangeAdd}
                  name="kodeAHS"
                  error={!ahsDataAdd.kodeAHS}
                  helperText={!ahsDataAdd.kodeAHS ? "Mandatory Field" : ""}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              {/* Section A */}
              <Box sx={{ p: 3, margin: "0 auto" }}>
                {/* Section A */}
                <Box
                  sx={{
                    mb: 4,
                    p: 2,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="h4" sx={{ mb: 3 }}>
                    Tenaga Kerja Management
                  </Typography>

                  {sectionsTenagaKerjaAdd.map((section, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 4,
                        p: 2,
                        border: "1px solid #ddd",
                        borderRadius: 1,
                        position: "relative",
                      }}
                    >
                      {sectionsTenagaKerjaAdd.length > 1 && (
                        <IconButton
                          onClick={() => removeSectionTenagaKerjaAdd(index)}
                          sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: "error.main",
                          }}
                        >
                          <Remove />
                        </IconButton>
                      )}

                      <Typography
                        variant="h5"
                        sx={{ mb: 2, fontWeight: "bold" }}
                      >
                        A. Tenaga Kerja{" "}
                        {sectionsTenagaKerjaAdd.length > 1
                          ? `#${index + 1}`
                          : ""}
                      </Typography>

                      <Typography
                        variant="subtitle1"
                        sx={{ mb: 1, fontWeight: "bold" }}
                      >
                        Item Category
                      </Typography>

                      <Autocomplete
                        options={
                          loadingCategoryItemsTK
                            ? []
                            : getAvailableTenagaKerjaItems(index)
                        }
                        getOptionLabel={(option) => option.name || ""}
                        value={
                          sectionsTenagaKerjaAdd[index]?.idTk
                            ? getAvailableTenagaKerjaItems(index).find(
                              (item) =>
                                item.id ===
                                sectionsTenagaKerjaAdd[index]?.idTk
                            ) || null
                            : null
                        }
                        onChange={(event, newValue) => {
                          handleItemSelectTKAdd(
                            index,
                            newValue ? newValue.id : ""
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Tenaga Kerja"
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            placeholder="Pilih atau cari Tenaga Kerja"
                          />
                        )}
                        loading={loadingCategoryItemsTK}
                        loadingText="Loading..."
                        noOptionsText={
                          loadingCategoryItemsTK
                            ? "Loading..."
                            : getAvailableTenagaKerjaItems(index).length === 0
                              ? allItemDetailsTK.length === 0
                                ? "Data belum tersedia"
                                : "Semua opsi sudah dipilih di section lain"
                              : "Tidak ada hasil yang cocok"
                        }
                        disabled={loadingCategoryItemsTK}
                      />
                      <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item xs={6}>
                          <TextField
                            label="Description"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.descriptionTenagaKerja}
                            name="descriptionTenagaKerja"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label="Koefisien (separator ,)"
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.koefisienTenagaKerja}
                            name="koefisienTenagaKerja"
                            error={!section.koefisienTenagaKerja}
                            helperText={
                              !section.koefisienTenagaKerja
                                ? "Mandatory Field"
                                : ""
                            }
                            onChange={(e) =>
                              handleKoefisienTenagaKerjaChangeAdd(
                                index,
                                e.target.value
                              )
                            }
                          />
                          <TextField
                            label="Harga Tenaga Kerja"
                            fullWidth
                            disabled
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.hargaTenagaKerja}
                            name="hargaTenagaKerja"
                            onChange={(e) =>
                              handleKoefisienTenagaKerjaChangeAdd(
                                index,
                                e.target.value
                              )
                            }
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  Rp
                                </InputAdornment>
                              ),
                              readOnly: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            label="Purchase Unit of Measurement"
                            fullWidth
                            disabled
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.purchaseUnitTenagaKerja}
                            name="purchaseUnitTenagaKerja"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label="Unit Price"
                            fullWidth
                            disabled
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.unitPriceIDRTenagaKerja}
                            name="unitPriceIDRTenagaKerja"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  Rp.
                                </InputAdornment>
                              ),
                              readOnly: true,
                            }}
                          />
                          {/* LOOPING */}
                          {Array.isArray(
                            sectionsTenagaKerjaAdd[index]
                              .unitMeasurementTenagaKerja
                          ) &&
                            sectionsTenagaKerjaAdd[
                              index
                            ].unitMeasurementTenagaKerja.map((val, index) => {
                            return (
                              <Grid container spacing={2} sx={{ mb: 1 }}>
                                <Grid item xs={8}>
                                  <TextField
                                    label="Input Unit Pengukuran"
                                    fullWidth
                                    disabled
                                    size="small"
                                    variant="outlined"
                                    value={val.unit}
                                    name="inputUnitTenagaKerja"
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={4}>
                                  <TextField
                                    label="Ukuran"
                                    fullWidth
                                    disabled
                                    size="small"
                                    variant="outlined"
                                    value={val.size}
                                    name="ukuranTenagaKerja"
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Grid>

                      {index === sectionsTenagaKerjaAdd.length - 1 && (
                        <Button
                          startIcon={<Add />}
                          onClick={addSectionTenagaKerjaAdd}
                          variant="outlined"
                          sx={{ mt: 1 }}
                        >
                          Add Another Tenaga Kerja
                        </Button>
                      )}
                    </Box>
                  ))}

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Jumlah Harga Tenaga Kerja"
                        fullWidth
                        size="small"
                        variant="outlined"
                        sx={{ mb: 1 }}
                        value={ahsDataAdd.jumlahHargaTenagaKerja}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              Rp.
                            </InputAdornment>
                          ),
                          readOnly: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* Section B */}
                <Box
                  sx={{
                    mb: 4,
                    p: 2,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="h4" sx={{ mb: 3 }}>
                    Bahan
                  </Typography>

                  {sectionsBahanAdd.map((section, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 4,
                        p: 2,
                        border: "1px solid #ddd",
                        borderRadius: 1,
                        position: "relative",
                      }}
                    >
                      {sectionsBahanAdd.length > 1 && (
                        <IconButton
                          onClick={() => removeSectionBahanAdd(index)}
                          sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: "error.main",
                          }}
                        >
                          <Remove />
                        </IconButton>
                      )}

                      <Typography
                        variant="h5"
                        sx={{ mb: 2, fontWeight: "bold" }}
                      >
                        B. Bahan{" "}
                        {sectionsBahanAdd.length > 1 ? `#${index + 1}` : ""}
                      </Typography>

                      <Typography
                        variant="subtitle1"
                        sx={{ mb: 1, fontWeight: "bold" }}
                      >
                        Item Category
                      </Typography>

                      <Autocomplete
                        options={
                          loadingCategoryItemsBahan
                            ? []
                            : getAvailableBahanItems(index)
                        }
                        getOptionLabel={(option) => option.name || ""}
                        value={
                          sectionsBahanAdd[index]?.idBahan
                            ? getAvailableBahanItems(index).find(
                              (item) =>
                                item.id === sectionsBahanAdd[index]?.idBahan
                            ) || null
                            : null
                        }
                        onChange={(event, newValue) => {
                          handleItemSelectBahanAdd(
                            index,
                            newValue ? newValue.id : ""
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Bahan"
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            placeholder="Pilih atau cari Bahan"
                          />
                        )}
                        loading={loadingCategoryItemsBahan}
                        loadingText="Memuat..."
                        noOptionsText={
                          loadingCategoryItemsBahan
                            ? "Memuat..."
                            : getAvailableBahanItems(index).length === 0
                              ? allItemDetailsBahan.length === 0
                                ? "Data belum tersedia"
                                : "Semua opsi sudah dipilih di section lain"
                              : "Tidak ada hasil yang cocok"
                        }
                        disabled={loadingCategoryItemsBahan}
                      />
                      <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item xs={6}>
                          <TextField
                            label="Description"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.descriptionBahan}
                            name="descriptionBahan"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label="Koefisien (separator ,)"
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.koefisienBahan}
                            name="koefisienBahan"
                            error={!section.koefisienBahan}
                            helperText={
                              !section.koefisienBahan ? "Mandatory Field" : ""
                            }
                            onChange={(e) =>
                              handleKoefisienBahanChangeAdd(
                                index,
                                e.target.value
                              )
                            }
                          />
                          <TextField
                            label="Harga Bahan"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.hargaBahan}
                            name="hargaBahan"
                            onChange={(e) =>
                              handleKoefisienBahanChangeAdd(
                                index,
                                e.target.value
                              )
                            }
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  Rp
                                </InputAdornment>
                              ),
                              readOnly: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            label="Purchase Unit of Measurement"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.purchaseUnitBahan}
                            name="purchaseUnitBahan"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label="Unit Price"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.unitPriceIDRBahan}
                            name="unitPriceIDRBahan"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  Rp.
                                </InputAdornment>
                              ),
                            }}
                          />
                          {/* LOOPING */}
                          {Array.isArray(
                            sectionsBahanAdd[index].unitMeasurementBahan
                          ) &&
                            sectionsBahanAdd[index].unitMeasurementBahan.map(
                              (val, index) => {
                              return (
                                <Grid container spacing={2} sx={{ mb: 1 }}>
                                  <Grid item xs={8}>
                                    <TextField
                                      label="Input Unit Pengukuran"
                                      fullWidth
                                      disabled
                                      size="small"
                                      variant="outlined"
                                      value={val.unit}
                                      name="inputUnitBahan"
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </Grid>
                                  <Grid item xs={4}>
                                    <TextField
                                      label="Ukuran"
                                      fullWidth
                                      disabled
                                      size="small"
                                      variant="outlined"
                                      value={val.size}
                                      name="ukuranBahan"
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              );
                            }
                          )}
                        </Grid>
                      </Grid>

                      {index === sectionsBahanAdd.length - 1 && (
                        <Button
                          startIcon={<Add />}
                          onClick={addSectionBahanAdd}
                          variant="outlined"
                          sx={{ mt: 1 }}
                        >
                          Add Another Bahan
                        </Button>
                      )}
                    </Box>
                  ))}

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Jumlah Harga Bahan"
                        fullWidth
                        size="small"
                        variant="outlined"
                        sx={{ mb: 1 }}
                        value={ahsDataAdd.jumlahHargaBahan}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              Rp.
                            </InputAdornment>
                          ),
                          readOnly: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* Section C */}
                <Box
                  sx={{
                    mb: 4,
                    p: 2,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="h4" sx={{ mb: 3 }}>
                    Peralatan
                  </Typography>

                  {sectionsPeralatanAdd.map((section, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 4,
                        p: 2,
                        border: "1px solid #ddd",
                        borderRadius: 1,
                        position: "relative",
                      }}
                    >
                      {sectionsPeralatanAdd.length > 1 && (
                        <IconButton
                          onClick={() => removeSectionPeralatanAdd(index)}
                          sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: "error.main",
                          }}
                        >
                          <Remove />
                        </IconButton>
                      )}

                      <Typography
                        variant="h5"
                        sx={{ mb: 2, fontWeight: "bold" }}
                      >
                        C. Peralatan{" "}
                        {sectionsPeralatanAdd.length > 1 ? `#${index + 1}` : ""}
                      </Typography>

                      <Typography
                        variant="subtitle1"
                        sx={{ mb: 1, fontWeight: "bold" }}
                      >
                        Item Category
                      </Typography>

                      <Autocomplete
                        options={
                          loadingCategoryItemsPeralatan
                            ? []
                            : getAvailablePeralatanItems(index)
                        }
                        getOptionLabel={(option) => option.name || ""}
                        value={
                          sectionsPeralatanAdd[index]?.idPeralatan
                            ? getAvailablePeralatanItems(index).find(
                              (item) =>
                                item.id ===
                                sectionsPeralatanAdd[index]?.idPeralatan
                            ) || null
                            : null
                        }
                        onChange={(event, newValue) => {
                          handleItemSelectPeralatanAdd(
                            index,
                            newValue ? newValue.id : ""
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Peralatan"
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            placeholder="Cari atau pilih Peralatan"
                          />
                        )}
                        loading={loadingCategoryItemsPeralatan}
                        loadingText="Memuat data..."
                        noOptionsText={
                          loadingCategoryItemsPeralatan
                            ? "Sedang memuat..."
                            : getAvailablePeralatanItems(index).length === 0
                              ? allItemDetailsPeralatan.length === 0
                                ? "Data peralatan belum tersedia"
                                : "Semua peralatan sudah dipilih di section lain"
                              : "Peralatan tidak ditemukan"
                        }
                        disabled={loadingCategoryItemsPeralatan}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        filterOptions={(options, state) =>
                          options.filter((option) =>
                            option.name
                              .toLowerCase()
                              .includes(state.inputValue.toLowerCase())
                          )
                        }
                      />
                      <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item xs={6}>
                          <TextField
                            label="Description"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.descriptionPeralatan}
                            name="descriptionPeralatan"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label="Koefisien (separator ,)"
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.koefisienPeralatan}
                            name="koefisienPeralatan"
                            error={!section.koefisienPeralatan}
                            helperText={
                              !section.koefisienPeralatan
                                ? "Mandatory Field"
                                : ""
                            }
                            onChange={(e) =>
                              handleKoefisienPeralatanChangeAdd(
                                index,
                                e.target.value
                              )
                            }
                          />
                          <TextField
                            label="Harga Peralatan"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.hargaPeralatan}
                            name="hargaPeralatan"
                            onChange={(e) =>
                              handleKoefisienPeralatanChangeAdd(
                                index,
                                e.target.value
                              )
                            }
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  Rp
                                </InputAdornment>
                              ),
                              readOnly: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            label="Purchase Unit of Measurement"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.purchaseUnitPeralatan}
                            name="purchaseUnitPeralatan"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label="Unit Price"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.unitPriceIDRPeralatan}
                            name="unitPriceIDRPeralatan"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  Rp.
                                </InputAdornment>
                              ),
                              readOnly: true,
                            }}
                          />
                          {/* LOOPING */}
                          {Array.isArray(
                            sectionsPeralatanAdd[index].unitMeasurementPeralatan
                          ) &&
                            sectionsPeralatanAdd[
                              index
                            ].unitMeasurementPeralatan.map((val, index) => {
                            return (
                              <Grid container spacing={2} sx={{ mb: 1 }}>
                                <Grid item xs={8}>
                                  <TextField
                                    label="Input Unit Pengukuran"
                                    fullWidth
                                    disabled
                                    size="small"
                                    variant="outlined"
                                    value={val.unit}
                                    name="inputUnitPeralatan"
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={4}>
                                  <TextField
                                    label="Ukuran"
                                    fullWidth
                                    disabled
                                    size="small"
                                    variant="outlined"
                                    value={val.size}
                                    name="ukuranPeralatan"
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Grid>

                      {index === sectionsPeralatanAdd.length - 1 && (
                        <Button
                          startIcon={<Add />}
                          onClick={addSectionPeralatanAdd}
                          variant="outlined"
                          sx={{ mt: 1 }}
                        >
                          Add Another Peralatan
                        </Button>
                      )}
                    </Box>
                  ))}

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Jumlah Harga Peralatan"
                        fullWidth
                        size="small"
                        variant="outlined"
                        sx={{ mb: 1 }}
                        value={ahsDataAdd.jumlahHargaPeralatan}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              Rp.
                            </InputAdornment>
                          ),
                          readOnly: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* Section D */}
                <Box
                  sx={{
                    mb: 4,
                    p: 2,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
                    D. Jumlah (A+B+C)
                  </Typography>

                  <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid item xs={6}>
                      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <TextField
                          label="Jumlah Harga A+B+C"
                          fullWidth
                          size="small"
                          variant="outlined"
                          sx={{ mb: 1 }}
                          value={totalJumlahHargaABCAdd.toLocaleString()}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                Rp.
                              </InputAdornment>
                            ),
                            readOnly: true,
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>

                {/* Section E */}
                <Box
                  sx={{
                    mb: 4,
                    p: 2,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
                    E. Overhead & Profit
                  </Typography>

                  <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid item xs={6}>
                      <TextField
                        label="Input Overhead & Profit Koefisien"
                        fullWidth
                        size="small"
                        variant="outlined"
                        value={ahsDataAdd.overheadProfitKoefisien}
                        name="overheadProfitKoefisien"
                        error={!ahsDataAdd.overheadProfitKoefisien}
                        helperText={
                          !ahsDataAdd.overheadProfitKoefisien
                            ? "Mandatory Field"
                            : ""
                        }
                        onChange={handleOverheadProfitChangeAdd}
                        sx={{ mb: 1 }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Jumlah Overhead & Profit Koefisien"
                        fullWidth
                        size="small"
                        variant="outlined"
                        name="jumlahOverheadProfitKoefisien"
                        value={ahsDataAdd.jumlahOverheadProfitKoefisien}
                        onChange={handleOverheadProfitChangeAdd}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">Rp</InputAdornment>
                          ),
                          readOnly: true,
                        }}
                        sx={{ mb: 1 }}
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* Section F */}
                <Box
                  sx={{
                    mb: 4,
                    p: 2,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
                    F. Harga Satuan Pekerjaan (D+E)
                  </Typography>
                  <TextField
                    label="Total Harga"
                    fullWidth
                    size="small"
                    variant="outlined"
                    value={totalJumlahHargaDEAdd.toLocaleString()}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      readOnly: true,
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="outlined"
            color="error"
            onClick={() => setOpenAddAHSDialog(false)}
          >
            CANCEL
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!ahsDataAdd.namaAHS || !ahsDataAdd.kategoriAHS}
            onClick={handleSaveAdd}
          >
            SAVE
          </Button>
        </DialogActions>
      </Dialog>
      {/* ================================ POPUP Edit AHS ======================================*/}
      <Dialog
        open={openEditAHSDialog}
        onClose={() => setOpenEditAHSDialog(false)}
        fullWidth
        maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Analisis Harga Satuan (AHS)
          </Typography>
          <IconButton onClick={handleCloseEdit} color="error">
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers id="ahs-edit-dialog-content">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              {/* Header section */}
              <Box sx={{ p: 2, borderBottom: "1px solid #e0e0e0" }}>
                <TextField
                  label="Nama AHS"
                  fullWidth
                  value={ahsDataEdit.namaAHS}
                  onChange={handleInputChangeEdit}
                  name="namaAHS"
                  sx={{ mb: 1 }}
                  error={!ahsDataEdit.namaAHS}
                  disabled={!isEditing}
                  helperText={
                    isEditing && !ahsDataEdit.namaAHS ? "Mandatory Field" : ""
                  }
                />
                <Autocomplete
                  options={kategoriOptions.map((option) => option.label)}
                  value={ahsDataEdit.kategoriAHS || null}
                  onChange={(event, newValue) => {
                    handleInputChangeEdit({
                      target: {
                        name: "kategoriAHS",
                        value: newValue || "",
                      },
                    });
                  }}
                  disabled={!isEditing}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Kategori AHS"
                      placeholder="Select Kategori"
                      fullWidth
                      sx={{ mb: 1 }}
                      error={isEditing && !ahsDataEdit.kategoriAHS}
                      helperText={
                        isEditing && !ahsDataEdit.kategoriAHS
                          ? "Mandatory Field"
                          : ""
                      }
                    />
                  )}
                  noOptionsText="No categories available"
                />
                <TextField
                  select
                  label="Sumber"
                  fullWidth
                  value={ahsDataEdit.sumber}
                  onChange={handleInputChangeEdit}
                  name="sumber"
                  error={!ahsDataEdit.sumber}
                  disabled={!isEditing}
                  helperText={
                    isEditing && !ahsDataEdit.sumber ? "Mandatory Field" : ""
                  }
                >
                  {sumberOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              {/* Header section */}
              <Box sx={{ p: 2, borderBottom: "1px solid #e0e0e0" }}>
                <TextField
                  label="Satuan AHS"
                  fullWidth
                  value={ahsDataEdit.satuanAHS}
                  onChange={handleInputChangeEdit}
                  name="satuanAHS"
                  sx={{ mb: 1 }}
                  error={!ahsDataEdit.satuanAHS}
                  disabled={!isEditing}
                  helperText={
                    isEditing && !ahsDataEdit.satuanAHS ? "Mandatory Field" : ""
                  }
                />
                <TextField
                  label="Kode AHS"
                  fullWidth
                  value={ahsDataEdit.kodeAHS}
                  onChange={handleInputChangeEdit}
                  name="kodeAHS"
                  error={!ahsDataEdit.kodeAHS}
                  disabled={!isEditing}
                  helperText={
                    isEditing && !ahsDataEdit.kodeAHS ? "Mandatory Field" : ""
                  }
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              {/* Section A */}
              <Box sx={{ p: 3, margin: "0 auto" }}>
                {/* Section A */}
                <Box
                  sx={{
                    mb: 4,
                    p: 2,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="h4" sx={{ mb: 3 }}>
                    Tenaga Kerja Management
                  </Typography>

                  {sectionsTenagaKerjaEdit.map((section, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 4,
                        p: 2,
                        border: "1px solid #ddd",
                        borderRadius: 1,
                        position: "relative",
                      }}
                    >
                      {sectionsTenagaKerjaEdit.length > 1 && (
                        <IconButton
                          disabled={!isEditing}
                          onClick={() => removeSectionTenagaKerjaEdit(index)}
                          sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: "error.main",
                          }}
                        >
                          <Remove />
                        </IconButton>
                      )}

                      <Typography
                        variant="h5"
                        sx={{ mb: 2, fontWeight: "bold" }}
                      >
                        A. Tenaga Kerja{" "}
                        {sectionsTenagaKerjaEdit.length > 1
                          ? `#${index + 1}`
                          : ""}
                      </Typography>

                      <Typography
                        variant="subtitle1"
                        sx={{ mb: 1, fontWeight: "bold" }}
                      >
                        Item Category
                      </Typography>

                      <Autocomplete
                        options={
                          loadingCategoryItemsTK
                            ? []
                            : getAvailableTenagaKerjaItems(index)
                        }
                        getOptionLabel={(option) => option.name || ""}
                        value={
                          sectionsTenagaKerjaEdit[index]?.idTk
                            ? getAvailableTenagaKerjaItems(index).find(
                              (item) =>
                                item.id ===
                                sectionsTenagaKerjaEdit[index]?.idTk
                            ) || null
                            : null
                        }
                        onChange={(event, newValue) => {
                          handleItemSelectTKEdit(
                            index,
                            newValue ? newValue.id : ""
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Tenaga Kerja"
                            fullWidth
                            disabled={!isEditing || loadingCategoryItemsTK}
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            placeholder="Pilih atau cari Tenaga Kerja"
                          />
                        )}
                        loading={loadingCategoryItemsTK}
                        loadingText="Memuat data..."
                        noOptionsText={
                          loadingCategoryItemsTK
                            ? "Sedang memuat..."
                            : getAvailableTenagaKerjaItems(index).length === 0
                              ? allItemDetailsTK.length === 0
                                ? "Data belum tersedia"
                                : "Semua opsi sudah dipilih di section lain"
                              : "Tidak ada hasil yang cocok"
                        }
                        disabled={!isEditing}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value?.id
                        }
                      />
                      <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item xs={6}>
                          <TextField
                            label="Description"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.descriptionTenagaKerja}
                            name="descriptionTenagaKerja"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label="Koefisien (separator ,)"
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.koefisienTenagaKerja}
                            name="koefisienTenagaKerja"
                            disabled={!isEditing}
                            error={!section.koefisienTenagaKerja}
                            helperText={
                              !section.koefisienTenagaKerja
                                ? "Mandatory Field"
                                : ""
                            }
                            onChange={(e) =>
                              handleKoefisienTenagaKerjaChangeEdit(
                                index,
                                e.target.value
                              )
                            }
                          />
                          <TextField
                            label="Harga Tenaga Kerja"
                            fullWidth
                            disabled
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.hargaTenagaKerja}
                            name="hargaTenagaKerja"
                            onChange={(e) =>
                              handleKoefisienTenagaKerjaChangeEdit(
                                index,
                                e.target.value
                              )
                            }
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  Rp
                                </InputAdornment>
                              ),
                              readOnly: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            label="Purchase Unit of Measurement"
                            fullWidth
                            disabled
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.purchaseUnitTenagaKerja}
                            name="purchaseUnitTenagaKerja"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label="Unit Price"
                            fullWidth
                            disabled
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.unitPriceIDRTenagaKerja}
                            name="unitPriceIDRTenagaKerja"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  Rp.
                                </InputAdornment>
                              ),
                              readOnly: true,
                            }}
                          />
                          {/* LOOPING */}
                          {Array.isArray(
                            sectionsTenagaKerjaEdit[index]
                              .unitMeasurementTenagaKerja
                          ) &&
                            sectionsTenagaKerjaEdit[
                              index
                            ].unitMeasurementTenagaKerja.map((val, index) => {
                            return (
                              <Grid container spacing={2} sx={{ mb: 1 }}>
                                <Grid item xs={8}>
                                  <TextField
                                    label="Input Unit Pengukuran"
                                    fullWidth
                                    disabled
                                    size="small"
                                    variant="outlined"
                                    value={val.unit}
                                    name="inputUnitTenagaKerja"
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={4}>
                                  <TextField
                                    label="Ukuran"
                                    fullWidth
                                    disabled
                                    size="small"
                                    variant="outlined"
                                    value={val.size}
                                    name="ukuranTenagaKerja"
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Grid>

                      {index === sectionsTenagaKerjaEdit.length - 1 && (
                        <Button
                          startIcon={<Add />}
                          onClick={addSectionTenagaKerjaEdit}
                          variant="outlined"
                          disabled={!isEditing}
                          sx={{ mt: 1 }}
                        >
                          Add Another Tenaga Kerja
                        </Button>
                      )}
                    </Box>
                  ))}

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Jumlah Harga Tenaga Kerja"
                        fullWidth
                        size="small"
                        variant="outlined"
                        sx={{ mb: 1 }}
                        disabled={!isEditing}
                        value={ahsDataEdit.jumlahHargaTenagaKerja}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              Rp.
                            </InputAdornment>
                          ),
                          readOnly: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* Section B */}
                <Box
                  sx={{
                    mb: 4,
                    p: 2,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="h4" sx={{ mb: 3 }}>
                    Bahan
                  </Typography>

                  {sectionsBahanEdit.map((section, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 4,
                        p: 2,
                        border: "1px solid #ddd",
                        borderRadius: 1,
                        position: "relative",
                      }}
                    >
                      {sectionsBahanEdit.length > 1 && (
                        <IconButton
                          disabled={!isEditing}
                          onClick={() => removeSectionBahanEdit(index)}
                          sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: "error.main",
                          }}
                        >
                          <Remove />
                        </IconButton>
                      )}

                      <Typography
                        variant="h5"
                        sx={{ mb: 2, fontWeight: "bold" }}
                      >
                        B. Bahan{" "}
                        {sectionsBahanEdit.length > 1 ? `#${index + 1}` : ""}
                      </Typography>

                      <Typography
                        variant="subtitle1"
                        sx={{ mb: 1, fontWeight: "bold" }}
                      >
                        Item Category
                      </Typography>

                      <Autocomplete
                        options={
                          loadingCategoryItemsPeralatan
                            ? []
                            : getAvailableBahanItems(index)
                        }
                        getOptionLabel={(option) => option.name || ""}
                        value={
                          sectionsBahanEdit[index]?.idBahan
                            ? getAvailableBahanItems(index).find(
                              (item) =>
                                item.id === sectionsBahanEdit[index]?.idBahan
                            ) || null
                            : null
                        }
                        onChange={(event, newValue) => {
                          handleItemSelectBahanEdit(
                            index,
                            newValue ? newValue.id : ""
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Bahan"
                            fullWidth
                            disabled={!isEditing || loadingCategoryItemsBahan}
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            placeholder="Pilih atau cari Bahan"
                          />
                        )}
                        loading={loadingCategoryItemsBahan}
                        loadingText="Memuat..."
                        noOptionsText={
                          loadingCategoryItemsBahan
                            ? "Memuat..."
                            : getAvailableBahanItems(index).length === 0
                              ? allItemDetailsBahan.length === 0
                                ? "Data belum tersedia"
                                : "Semua opsi sudah dipilih di section lain"
                              : "Tidak ada hasil yang cocok"
                        }
                        disabled={!isEditing}
                      />
                      <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item xs={6}>
                          <TextField
                            label="Description"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.descriptionBahan}
                            name="descriptionBahan"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label="Koefisien (separator ,)"
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.koefisienBahan}
                            name="koefisienBahan"
                            disabled={!isEditing}
                            error={!section.koefisienBahan}
                            helperText={
                              !section.koefisienBahan ? "Mandatory Field" : ""
                            }
                            onChange={(e) =>
                              handleKoefisienBahanChangeEdit(
                                index,
                                e.target.value
                              )
                            }
                          />
                          <TextField
                            label="Harga Bahan"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.hargaBahan}
                            name="hargaBahan"
                            onChange={(e) =>
                              handleKoefisienBahanChangeEdit(
                                index,
                                e.target.value
                              )
                            }
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  Rp
                                </InputAdornment>
                              ),
                              readOnly: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            label="Purchase Unit of Measurement"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.purchaseUnitBahan}
                            name="purchaseUnitBahan"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label="Unit Price"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.unitPriceIDRBahan}
                            name="unitPriceIDRBahan"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  Rp.
                                </InputAdornment>
                              ),
                            }}
                          />
                          {/* LOOPING */}
                          {Array.isArray(
                            sectionsBahanEdit[index].unitMeasurementBahan
                          ) &&
                            sectionsBahanEdit[index].unitMeasurementBahan.map(
                              (val, index) => {
                              return (
                                <Grid container spacing={2} sx={{ mb: 1 }}>
                                  <Grid item xs={8}>
                                    <TextField
                                      label="Input Unit Pengukuran"
                                      fullWidth
                                      disabled
                                      size="small"
                                      variant="outlined"
                                      value={val.unit}
                                      name="inputUnitBahan"
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </Grid>
                                  <Grid item xs={4}>
                                    <TextField
                                      label="Ukuran"
                                      fullWidth
                                      disabled
                                      size="small"
                                      variant="outlined"
                                      value={val.size}
                                      name="ukuranBahan"
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              );
                            }
                          )}
                        </Grid>
                      </Grid>

                      {index === sectionsBahanEdit.length - 1 && (
                        <Button
                          disabled={!isEditing}
                          startIcon={<Add />}
                          onClick={addSectionBahanEdit}
                          variant="outlined"
                          sx={{ mt: 1 }}
                        >
                          Add Another Bahan
                        </Button>
                      )}
                    </Box>
                  ))}

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Jumlah Harga Bahan"
                        fullWidth
                        size="small"
                        variant="outlined"
                        sx={{ mb: 1 }}
                        disabled={!isEditing}
                        value={ahsDataEdit.jumlahHargaBahan}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              Rp.
                            </InputAdornment>
                          ),
                          readOnly: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* Section C */}
                <Box
                  sx={{
                    mb: 4,
                    p: 2,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="h4" sx={{ mb: 3 }}>
                    Peralatan
                  </Typography>

                  {sectionsPeralatanEdit.map((section, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 4,
                        p: 2,
                        border: "1px solid #ddd",
                        borderRadius: 1,
                        position: "relative",
                      }}
                    >
                      {sectionsPeralatanEdit.length > 1 && (
                        <IconButton
                          disabled={!isEditing}
                          onClick={() => removeSectionPeralatanEdit(index)}
                          sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: "error.main",
                          }}
                        >
                          <Remove />
                        </IconButton>
                      )}

                      <Typography
                        variant="h5"
                        sx={{ mb: 2, fontWeight: "bold" }}
                      >
                        C. Peralatan{" "}
                        {sectionsPeralatanEdit.length > 1
                          ? `#${index + 1}`
                          : ""}
                      </Typography>

                      <Typography
                        variant="subtitle1"
                        sx={{ mb: 1, fontWeight: "bold" }}
                      >
                        Item Category
                      </Typography>

                      <Autocomplete
                        options={
                          loadingCategoryItemsPeralatan
                            ? []
                            : getAvailablePeralatanItems(index)
                        }
                        getOptionLabel={(option) => option.name || ""}
                        value={
                          sectionsPeralatanEdit[index]?.idPeralatan
                            ? getAvailablePeralatanItems(index).find(
                              (item) =>
                                item.id ===
                                sectionsPeralatanEdit[index]?.idPeralatan
                            ) || null
                            : null
                        }
                        onChange={(event, newValue) => {
                          handleItemSelectPeralatanEdit(
                            index,
                            newValue ? newValue.id : ""
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Peralatan"
                            fullWidth
                            disabled={
                              !isEditing || loadingCategoryItemsPeralatan
                            }
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            placeholder="Pilih atau cari Peralatan"
                          />
                        )}
                        loading={loadingCategoryItemsPeralatan}
                        loadingText="Memuat..."
                        noOptionsText={
                          loadingCategoryItemsPeralatan
                            ? "Memuat..."
                            : getAvailablePeralatanItems(index).length === 0
                              ? allItemDetailsPeralatan.length === 0
                                ? "Data belum tersedia"
                                : "Semua opsi sudah dipilih di section lain"
                              : "Tidak ada hasil yang cocok"
                        }
                        disabled={!isEditing}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                      />
                      <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item xs={6}>
                          <TextField
                            label="Description"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.descriptionPeralatan}
                            name="descriptionPeralatan"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label="Koefisien (separator ,)"
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.koefisienPeralatan}
                            name="koefisienPeralatan"
                            disabled={!isEditing}
                            error={!section.koefisienPeralatan}
                            helperText={
                              !section.koefisienPeralatan
                                ? "Mandatory Field"
                                : ""
                            }
                            onChange={(e) =>
                              handleKoefisienPeralatanChangeEdit(
                                index,
                                e.target.value
                              )
                            }
                          />
                          <TextField
                            label="Harga Peralatan"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.hargaPeralatan}
                            name="hargaPeralatan"
                            onChange={(e) =>
                              handleKoefisienPeralatanChangeEdit(
                                index,
                                e.target.value
                              )
                            }
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  Rp
                                </InputAdornment>
                              ),
                              readOnly: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            label="Purchase Unit of Measurement"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.purchaseUnitPeralatan}
                            name="purchaseUnitPeralatan"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label="Unit Price"
                            disabled
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{ mb: 1 }}
                            value={section.unitPriceIDRPeralatan}
                            name="unitPriceIDRPeralatan"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  Rp.
                                </InputAdornment>
                              ),
                              readOnly: true,
                            }}
                          />
                          {/* LOOPING */}
                          {Array.isArray(
                            sectionsPeralatanEdit[index]
                              .unitMeasurementPeralatan
                          ) &&
                            sectionsPeralatanEdit[
                              index
                            ].unitMeasurementPeralatan.map((val, index) => {
                            return (
                              <Grid container spacing={2} sx={{ mb: 1 }}>
                                <Grid item xs={8}>
                                  <TextField
                                    label="Input Unit Pengukuran"
                                    fullWidth
                                    disabled
                                    size="small"
                                    variant="outlined"
                                    value={val.unit}
                                    name="inputUnitPeralatan"
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={4}>
                                  <TextField
                                    label="Ukuran"
                                    fullWidth
                                    disabled
                                    size="small"
                                    variant="outlined"
                                    value={val.size}
                                    name="ukuranPeralatan"
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Grid>

                      {index === sectionsPeralatanAdd.length - 1 && (
                        <Button
                          disabled={!isEditing}
                          startIcon={<Add />}
                          onClick={addSectionPeralatanEdit}
                          variant="outlined"
                          sx={{ mt: 1 }}
                        >
                          Add Another Peralatan
                        </Button>
                      )}
                    </Box>
                  ))}

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Jumlah Harga Peralatan"
                        fullWidth
                        disabled={!isEditing}
                        size="small"
                        variant="outlined"
                        sx={{ mb: 1 }}
                        value={ahsDataEdit.jumlahHargaPeralatan}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              Rp.
                            </InputAdornment>
                          ),
                          readOnly: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* Section D */}
                <Box
                  sx={{
                    mb: 4,
                    p: 2,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
                    D. Jumlah (A+B+C)
                  </Typography>

                  <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid item xs={6}>
                      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <TextField
                          label="Jumlah Harga A+B+C"
                          fullWidth
                          disabled={!isEditing}
                          size="small"
                          variant="outlined"
                          sx={{ mb: 1 }}
                          value={totalJumlahHargaABCEdit.toLocaleString()}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                Rp.
                              </InputAdornment>
                            ),
                            readOnly: true,
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>

                {/* Section E */}
                <Box
                  sx={{
                    mb: 4,
                    p: 2,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
                    E. Overhead & Profit
                  </Typography>

                  <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid item xs={6}>
                      <TextField
                        label="Input Overhead & Profit Koefisien"
                        fullWidth
                        size="small"
                        variant="outlined"
                        disabled={!isEditing}
                        value={ahsDataEdit.overheadProfitKoefisien}
                        name="overheadProfitKoefisien"
                        error={!ahsDataEdit.overheadProfitKoefisien}
                        helperText={
                          !ahsDataEdit.overheadProfitKoefisien
                            ? "Mandatory Field"
                            : ""
                        }
                        onChange={handleOverheadProfitChangeEdit}
                        sx={{ mb: 1 }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Jumlah Overhead & Profit Koefisien"
                        fullWidth
                        size="small"
                        variant="outlined"
                        disabled={!isEditing}
                        name="jumlahOverheadProfitKoefisien"
                        value={ahsDataEdit.jumlahOverheadProfitKoefisien}
                        onChange={handleOverheadProfitChangeEdit}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">Rp</InputAdornment>
                          ),
                          readOnly: true,
                        }}
                        sx={{ mb: 1 }}
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* Section F */}
                <Box
                  sx={{
                    mb: 4,
                    p: 2,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
                    F. Harga Satuan Pekerjaan (D+E)
                  </Typography>
                  <TextField
                    label="Total Harga"
                    fullWidth
                    size="small"
                    variant="outlined"
                    disabled={!isEditing}
                    value={totalJumlahHargaDEEdit.toLocaleString()}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      readOnly: true,
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        {/* Buttons: Save & Close */}
        <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
          {!isEditing ? (
            <>
              <Button
                onClick={() => setIsEditing(true)}
                variant="contained"
                color="primary"
              >
                EDIT
              </Button>
              <Button
                onClick={exportToPDF}
                variant="outlined"
                startIcon={<PictureAsPdf />}
                color="error"
                sx={{ mr: 1 }}
              >
                Export PDF
              </Button>
              <Button
                onClick={exportToSingleSheetExcel}
                variant="outlined"
                color="secondary"
                startIcon={<Download />} // Icon ekspor
              >
                Export Excel
              </Button>
            </>
          ) : (
            <>
              <Button
                onClick={() => setIsEditing(false)}
                variant="outlined"
                color="error"
              >
                CANCEL
              </Button>
              <Button
                onClick={handleSaveEdit}
                variant="contained"
                color="success"
              >
                SAVE
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AHSListPage;
